import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import O2img from "../assets/kangaroo/O2image.png"
import bgImage from "../assets/kangaroo/bg_icon.svg";
import "./Component/Homepage.css";
import logo from "../assets/kangaroo/logo.svg";
import Kcomponent from "./Component/Kcomponent";
import MainComponent from "./Component/MainComponent";
import ausImg from "../assets/kangaroo/australiahover.png";
import AustralianSVG2 from "../Homepage/Component/AustrialianSVG";
import { AnimatePresence, motion } from "framer-motion";
import newImg from "../assets/kangaroo/newhover.png";
import aus2Umg from "../assets/kangaroo/a2hover.png";
import rImg from "../assets/kangaroo/rhover.png";
import O1img from "../assets/kangaroo/O1hover.png";
import { isObjectLike } from "lodash";
import Ncomponent from "./Component/Ncomponent";
import A2component from "./Component/A2component";
import Gcomponent from "./Component/Gcomponent";
import Rcomponent from "./Component/Rcomponent";

import SmallPage from "./SmallPage";
import Professional from "./Professional";
import SectionContainer from "./SectionContainer";
import SmartPreparation from "./SmartPreparation";
import Explore from "./Explore";
import Review from "./Review";
import Map from "./Map";
import O1component from "./Component/O1component";
import O2component from "./Component/O2component";
import LearnMore from "./LearnMore";
import DestinationSelect from "./DestinationSelect";
import JoinSuccess from "./JoinSuccess";
import AustralianSVG from "../Homepage/Component/AustrialianSVG";
import Professional2 from "./Professiona2";
import HomeSectionService from "../services/HomeSectionService";
import SVGService from "../services/SvgAnimationService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../services/imageBaseApi";
import { useNavigate } from "react-router-dom";

const Homepage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [animationDone, setAnimationDone] = useState(false);
  // const [hoveredLetter, setHoveredLetter] = useState(null);
  const [hoveredElement, setHoveredElement] = useState(null);
  const [childHovered, setChildHovered] = useState(false);

  const [hoveredLetter, _setHoveredLetter] = useState(null);

  const setHoveredLetter = (value) => {
    if (value === null) {
      console.trace("🚨 setHoveredLetter(null) CALLED");

    }
    _setHoveredLetter(value);
  };

  const router = useNavigate()
  const [animationDone1, setAnimationDone1] = useState({
    K: false,
    A1: false,
    N: false,
    G: false,
    A2: false,
    R: false,
    O1: false,
    O2: false,
  });

  const contentHeight = 340;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const o2Variants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.3, ease: "easeInOut", delay: 0.3 } // only for hover-in
    },
    exit: {
      opacity: 0,
      scale: 0.95,
      transition: { duration: 0.3, ease: "easeInOut" } // no delay for hover-out
    }
  };
  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle animation complete for specific letter
  const handleAnimationComplete = (letter) => {
    setAnimationDone1((prev) => ({ ...prev, [letter]: true }));
  };

  const fetchData = async () => {
    const response = await HomeSectionService.getList();
    console.log(response)
  }


  const originalColors = {
    K: "#7E1790",
    A1: "#FF4D1D",
    N: "#AEF611",
    G: "#0FEDED",
    A2: "#1900DA",
    R: "#D70A84",
    O1: "#EA381D",
    O2: "#7A0708",
    dim: "#d6dced",
  };

  const allElements = document.querySelectorAll('svg [class^="st"]');
  const reDraw = (letter) => {
    // Get all st* elements fresh each time

    allElements.forEach((el) => {
      if (letter === null) {
        // Restore all original fills if no hover
        el.style.fill = el.getAttribute("fill");
      } else {
        // Dim all except the hovered element
        if (el.id === letter) {
          el.style.fill = el.getAttribute("fill"); // restore hovered
        } else {
          el.style.fill = originalColors.dim; // dim others
        }
      }
    });
  };


  useEffect(() => {
    reDraw(hoveredLetter);
  }, [hoveredLetter]);

  console.log(hoveredLetter)

  const [countrydata, setCountrydata] = useState([])

  const fetchCountryData = async () => {
    try {
      const response = await HomeSectionService.getList();
      setCountrydata(response)
    } catch (error) {
      console.error("Error fetching country data:", error);
      return null;
    }
  };

  const fetchBannerData = async () => {
    const response = await SVGService.getList();
    return response
  }

  const { isPending, error, data: bannerData } = useQuery({
    queryKey: ["bannerData"],
    queryFn: fetchBannerData,
  })

  const [showMain, setShowMain] = useState(true);

  useEffect(() => {
    let timer;

    if (hoveredLetter === null) {
      timer = setTimeout(() => {
        setShowMain(true);
      }, 0); // 0.5 sec
    } else {
      setShowMain(false);
    }

    return () => clearTimeout(timer);
  }, [hoveredLetter]);


  useEffect(() => {
    fetchCountryData();
  }, []);


  console.log(countrydata)
  const filterMain = bannerData?.filter((item) => item?.slug === "start-smart")

  const filterK = bannerData?.filter((item) => item?.slug === "knowladage-guidance")

  const filterA1 = bannerData?.filter((item) => item?.slug === "visa-and-migration-support")
  const filterN = bannerData?.filter((item) => item?.slug === "admissions-enrollment-support")
  const filterG = bannerData?.filter((item) => item?.slug === "matche-with-right-support")
  const filterA2 = bannerData?.filter((item) => item?.slug === "assurance-osch-ovhc")
  const filterR = bannerData?.filter((item) => item?.slug === "return-filing-tax")
  const filterO1 = bannerData?.filter((item) => item?.slug === "onshore-help-desk")
  const filterO2 = bannerData?.filter((item) => item?.slug === "suppor-across-australia")

  const filterDiscover = countrydata.filter((item) => item?.slug === "guided-students-success")
  const filterExplore = countrydata.filter((item) => item?.slug === "explore-services")
  const filterEmpower = countrydata.filter((item) => item?.slug === "empowering-to-start-smart")
  const filterTest = countrydata.filter((item) => item?.slug === "find-support-you-need")

  return (
    <div style={{ overflowX: "hidden" }} className="py-4">
      <SectionContainer>
        <div className="main-container" style={{
          marginBottom: hoveredLetter === "A1" || hoveredLetter === "N" || hoveredLetter === "A2" || hoveredLetter === "R" || hoveredLetter === "O1" && isMobile === true || hoveredLetter === "O2" && isMobile === true || hoveredLetter === "K" && isMobile === true || hoveredLetter === "G" && isMobile === true ? "14.9rem" : "4.9rem",
        }}>
          {/* <header className="p-4">
            <Navbar />
          </header> */}

          <div className="container">
            <Row>
              <Col
                lg={5}
                className="d-flex justify-content-start align-items-center p-lg-0 p-3 "
              >
                {showMain && <MainComponent data={filterMain}/>}
              </Col>

              {/* {selectedComponent === "a" && (
            <div
              className=" w-25"
              style={{
                position: "absolute",
                top: "320px", 
                left: "477px",
                height: "auto",
              }}
            >
             
              <AustralianSVG />
            </div>
          )} */}
              <Col lg={1}></Col>

              <Col lg={6}>
                <svg
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  viewBox="0 0 1120 1350"
                  style={{ overflow: "visible" }}
                >

                  <defs>
                    <clipPath id="clip">
                      <rect x={400} y={310} width={200} height={345} />
                    </clipPath>
                  </defs>



                  <AnimatePresence mode="wait">



                    {(hoveredLetter === "N" || hoveredLetter === "A1") && (<rect
                      x="90"
                      y="475"
                      width="475"
                      height="480"
                      fill="transparent"
                      style={{ cursor: "pointer" }}
                      onMouseEnter={() => !isMobile && setHoveredLetter("G")}
                      onMouseLeave={() => !isMobile && setHoveredLetter(null)}
                    />)}

                    {/* {hoveredLetter === "N" && (
  <motion.foreignObject
    key="N-image"
    x={-1100}
    y={590}
    width="100%"
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
    style={{ overflow: "visible" }}
  >
    <div
      xmlns="http://www.w3.org/1999/xhtml"
      style={{ width: "100%", height: "100%" }}
    >
      <img
        src={newImg}
        style={{ width: "70%" }}
        alt="New Zealand"
      />
    </div>
  </motion.foreignObject>
)} */}

                    {hoveredLetter === "A2" && isMobile === false && (
                      <motion.foreignObject
                        key="A2-image"
                        x={-1330}
                        y={605}
                        width="70%"
                        height="40%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <img
                            src={imageBaseApi + filterA2?.[0]?.media?.url}
                            style={{ width: "100%", height: "100%" }}
                            alt="Australia"
                          />
                        </div>
                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "K" && isMobile === false && (
                      <motion.foreignObject
                        key="K-image-3"
                        x={-1420}
                        y={385}
                        width="60%"
                        height="50%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <img
                            src={imageBaseApi + filterK?.[0]?.media?.url}
                            style={{ width: "83%", }}
                            alt="hello"
                          />
                        </div>
                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "G" && isMobile === false && (
                      <motion.foreignObject
                        key="G-image-3"
                        x={-810}
                        y={155}
                        width="60%"
                        height="50%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <img
                            style={{ width: "45%", }}
                            src={imageBaseApi + filterG?.[0]?.media?.url}
                            alt="hello"
                          />
                        </div>
                      </motion.foreignObject>
                    )}




                    {hoveredLetter === "R" && isMobile === false && (
                      <motion.foreignObject
                        key="R-image"
                        x={-690}
                        y={280}
                        width="40%"
                        height="35%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <img
                            src={imageBaseApi + filterR?.[0]?.media?.url}
                            style={{ width: "100%", height: "100%" }}
                            alt="R Image"
                          />
                        </div>
                      </motion.foreignObject>
                    )}
                    {hoveredLetter === "R" && (
                      <g>


                        <rect
                          x="660"
                          y="475"
                          width="295"
                          height="340"
                          fill="transparent"
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => setHoveredLetter("R")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        />
                        <rect
                          x="420"
                          y="790"
                          width="595"
                          height="230"
                          fill="transparent"
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => setHoveredLetter("R")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        />

                      </g>
                    )}

                    {hoveredLetter === "R" && isMobile === false && (
                      <motion.foreignObject
                        key="R"
                        x="-665"
                        y="790"
                        width="100%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div xmlns="http://www.w3.org/1999/xhtml">
                          <Rcomponent isMobile={isMobile}
                            data={filterR}
                            setHoveredLetter={setHoveredLetter}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </div>
                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "O2" && isMobile === false && (
                      <motion.foreignObject
                        key="O2-image"
                        x={-1190}
                        y={100}
                        width="95%"
                        height="80%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{ width: "100%", height: "100%" }}
                        >
                          {/* Your content here */}
                        </div>
                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "O1" && isMobile === false && (
                      <motion.foreignObject
                        key="O1-image"
                        x={-790}
                        y={40}
                        width="100%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      >
                        <div
                          xmlns="http://www.w3.org/1999/xhtml"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <img
                            src={imageBaseApi + filterO1?.[0]?.media?.url}
                            style={{ width: "40%" }}
                            alt="O1 Image"
                          />
                        </div>
                      </motion.foreignObject>
                    )}
                    {hoveredLetter === "K" && isMobile === false && (
                      <motion.foreignObject
                        key="K-desktop"
                        x="-1400"
                        y="165"
                        width="65%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{
                          overflow: "visible",
                          transformOrigin: "top left",
                        }}
                      // onMouseEnter={() => setHoveredLetter("K")}
                      // onMouseLeave={() => setHoveredLetter(null)}
                      >
                        <div
                          style={{
                            width: "78%",
                            height: "auto",
                            transform: "scale(2.5)",
                            transformOrigin: "top left",
                          }}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <Kcomponent setHoveredLetter={setHoveredLetter} isMobile={isMobile} data={filterK} />
                        </div>
                      </motion.foreignObject>
                    )}




                    {hoveredLetter === "O1" && isMobile === false && (
                      <motion.foreignObject
                        key="O1-desktop"
                        x="-800"
                        y="600"
                        width="50%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{
                          overflow: "visible",
                          transformOrigin: "top left",
                        }}
                        onMouseEnter={() => setHoveredLetter("O1")}
                        onMouseLeave={() => setHoveredLetter(null)}
                      >
                        <div
                          style={{
                            width: "105%",
                            height: "20%",
                            transform: "scale(2.5) translateX(-145px)",
                            transformOrigin: "top left",
                          }}
                        >
                          <O1component isMobile={isMobile} data={filterO1} />
                        </div>
                      </motion.foreignObject>
                    )}



                    {hoveredLetter === "A1" && isMobile === false && (
                      <motion.foreignObject
                        key="A1-desktop"
                        x="-1180"
                        y="355"
                        width="100%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                      // onMouseEnter={() => setHoveredLetter("A1")}
                      // onMouseLeave={() => setHoveredLetter(null)}
                      >
                        <div xmlns="http://www.w3.org/1999/xhtml">
                          <AustralianSVG
                            style={{
                              width: "100%",
                              height: "100%"
                            }}
                            isMobile={isMobile}
                            data={filterA1}
                            setHoveredLetter={setHoveredLetter}
                          />
                        </div>
                      </motion.foreignObject>
                    )}



                    {hoveredLetter === "K" && isMobile === true && (
                      <motion.foreignObject
                        key="K-mobile"
                        x="-45"
                        y="480"
                        width="100%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                        onMouseEnter={() => setHoveredLetter("K")}
                        onMouseLeave={() => setHoveredLetter(null)}
                      >
                        <div xmlns="http://www.w3.org/1999/xhtml">
                          <Kcomponent
                            data={filterK}
                            style={{ width: "100%", height: "100%" }}
                            isMobile={isMobile}
                          />
                        </div>
                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "K" && isMobile === true && (
                      <motion.foreignObject
                        key="K-mobile-1"
                        x="-150"
                        y="260"
                        width="60%"

                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}
                        onMouseEnter={() => setHoveredLetter("K")}
                        onMouseLeave={() => setHoveredLetter(null)}
                      >

                        <img src={imageBaseApi + filterK?.[0]?.media?.url} style={{ width: "40%" }} alt="" />


                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "N" && isMobile === false && (
                      <motion.foreignObject
                        key="N-desktop"
                        x="-1180"
                        y="355"
                        width="100%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}

                      >
                        <div xmlns="http://www.w3.org/1999/xhtml">
                          <Ncomponent setHoveredLetter={setHoveredLetter} isMobile={isMobile} data={filterN}
                            style={{ width: "100%", height: "100%", border: "1px solid black" }}
                          />
                        </div>
                      </motion.foreignObject>
                    )}

                    {hoveredLetter === "A2" && (<rect
                      x="420"
                      y="790"
                      width="595"
                      height="230"
                      fill="transparent"
                      style={{ cursor: "pointer" }}
                      onMouseEnter={() => setHoveredLetter("A2")}
                      onMouseLeave={() => setHoveredLetter(null)}
                    />)}

                    {hoveredLetter === "A2" && isMobile === false && (
                      <motion.foreignObject
                        key="A2"
                        x="-595"
                        y="790"
                        width="100%"
                        height="100%"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: "visible" }}

                      >
                        <div xmlns="http://www.w3.org/1999/xhtml">
                          <A2component
                            isMobile={isMobile}
                            data={filterA2}
                            setHoveredLetter={setHoveredLetter}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </div>
                      </motion.foreignObject>
                    )}


                    {hoveredLetter === "G" && isMobile === false && (
                      <>

                        <motion.foreignObject
                          key="G-desktop"
                          x="-1115"
                          y="170"
                          width="50%"
                          height="100%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{
                            overflow: "visible",
                            transformOrigin: "top left",



                          }}

                        >

                          <div
                            style={{
                              width: "105%",
                              height: "auto",
                              transform: "scale(2.5)",
                              transformOrigin: "top left",


                            }}
                            onMouseEnter={() => setHoveredLetter("G")}

                            className="d-flex justify-content-center align-items-center"
                          >
                            <Gcomponent isMobile={isMobile} data={filterG} />
                          </div>


                        </motion.foreignObject>

                      </>
                    )}

                    {hoveredLetter === "G" && isMobile === false && (<><rect x="-800" y="250" width="948.37" height="216.06" fill="transparent" onMouseEnter={() => setHoveredLetter(null)} pointerEvents="all" /> <rect x="-1100" y="250" width="248.37" height="916.06" fill="transparent" onMouseEnter={() => setHoveredLetter(null)} pointerEvents="all" /></>)}



                    {/* {hoveredLetter === "G" && (<rect x="-600" y="250" width="748.37" height="816.06" fill="blue" onMouseEnter={() => setHoveredLetter("G")} onMouseLeave={() => setHoveredLetter(null)}/>)} */}







                  </AnimatePresence>
                  {/* ROW 1 */}
                  <g>
                    <g>
                      <motion.polygon
                        id="K"
                        style={{ cursor: "pointer" }}
                        className="st9"
                        points="209.15 173.67 141.08 173.67 141.08 450.6 209.15 450.6 209.16 356.47 311.61 450.6 414.05 450.6 262.57 308.24 414.05 166.68 311.61 166.68 209.16 260 209.15 173.67"
                        //fill={hoveredLetter === "K" ? "#7E1790" : originalColors.dim}
                        //fill={hoveredElement === "K" ? "#ccc" : "#000"}
                        stroke={animationDone1.K ? "none" : originalColors.K}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: originalColors.K, //(isLoading || hoveredLetter == 'K') ? originalColors.K : originalColors.dim,
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() => handleAnimationComplete("K")}
                        onMouseEnter={() => setHoveredLetter("K")}
                        onMouseLeave={() => setHoveredLetter(null)}
                      />
                    </g>

                    <g>
                      {/* The actual path */}
                      <motion.path
                        id="A1"
                        className="st0"
                        d="M595.13,173.67v21.55c-10.99-8.24-23.66-15.08-38.02-20.45-14.38-5.39-30.84-8.09-49.35-8.09-20.8,0-40,3.68-57.59,11.05-17.57,7.37-32.8,17.49-45.66,30.43-12.86,12.93-22.88,28.02-30.08,45.27-7.18,17.23-10.76,35.73-10.76,55.49s3.58,37.71,10.76,54.96c7.2,17.23,17.22,32.31,30.08,45.25,12.86,12.93,28.09,23.08,45.66,30.45,17.59,7.34,36.8,11.03,57.59,11.03.92,0,1.77-.11,2.68-.12,1.01.02,1.98.12,3,.12,20.66,0,40.04-3.65,58.12-10.91v-76.64c-.09.09-.18.18-.27.27-7.94,7.54-16.83,13.2-26.66,16.97-9.83,3.77-20.22,5.66-31.19,5.66-4.5,0-8.89-.4-13.22-1.03h0c-6.25-.91-12.35-2.4-18.27-4.63-10.04-3.77-18.84-9.43-26.39-16.97-15.88-15.08-23.82-33.21-23.82-54.41s7.94-39.88,23.82-54.96c7.55-7.17,16.34-12.74,26.39-16.71,10.02-3.95,20.5-5.92,31.49-5.92,22.69,0,41.97,7.54,57.85,22.62,15.88,15.08,23.85,33.41,23.85,54.96v141.69h68.07V173.67h-68.07Z"
                        stroke={animationDone1.A1 ? "none" : originalColors.A1}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: originalColors.A1,
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() =>
                          handleAnimationComplete("A1")
                        }
                        onMouseEnter={() => setHoveredLetter("A1")}
                        onMouseLeave={() => setHoveredLetter(null)}
                        style={{ pointerEvents: 'all' }}
                      />
                    </g>

                    <g>
                      <motion.path
                        className="st6"
                        id="N"
                        d="M826.51,166.68c18.54,0,35.36,3.33,50.51,9.97,15.12,6.64,28.07,15.81,38.85,27.47,10.78,11.68,19.09,25.23,24.95,40.67,5.86,15.46,8.79,31.99,8.79,49.57v156.25h-68.07v-156.25c0-17.95-6.63-32.86-19.85-44.7-12.86-12.21-28.37-18.33-46.51-18.33s-34.23,6.12-47.09,18.33c-12.86,12.21-19.3,27.12-19.3,44.7v156.25h-68.06V174.22h68.06v20.48c10.23-8.26,21.75-15,34.63-20.21,12.83-5.2,27.22-7.8,43.1-7.8Z"
                        fill={
                          hoveredLetter === "N"
                            ? originalColors.N
                            : originalColors.dim
                        }
                        stroke={animationDone1.N ? "none" : "#AEF611"}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: originalColors.N,
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() => handleAnimationComplete("N")}
                        onMouseEnter={() => setHoveredLetter("N")}
                        onMouseLeave={() => setHoveredLetter(null)}

                      />
                      {(<rect
                        x="665"
                        y="175"
                        width="295"
                        height="280"
                        fill="transparent"
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() => setHoveredLetter("N")}
                        onMouseLeave={() => setHoveredLetter(null)}
                      />)}




                      <defs>
                        <clipPath id="myClip" clipPathUnits="objectBoundingBox">
                          <polygon points="0.25 0.52, 0.50 0.52, 0.50 0.25, 0.75 0.25, 0.75 0.75, 0.25 0.75" />
                        </clipPath>
                      </defs>

                      <rect
                        x={-355}
                        y={10}
                        width={975}
                        height={630}
                        fill="transparent"
                        clipPath="url(#myClip)"
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() => setHoveredLetter("K")}
                        onMouseLeave={() => {
                          if (!isMobile) {
                            setHoveredLetter(null);
                          }
                        }}

                      />
                      <rect
                        x={-316}
                        y={420}
                        width={975}
                        height={70}
                        fill="transparent"
                        clipPath="url(#myClip)"
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() => setHoveredLetter("K")}
                        onMouseLeave={() => setHoveredLetter(null)}
                      />
                    </g>

                  </g>

                  {/* ROW 2 */}

                  <motion.g
                    animate={{
                      y:
                        hoveredLetter === "A1" ||
                          hoveredLetter === "N" ||
                          (hoveredLetter === "K" && isMobile)
                          ? contentHeight
                          : 0,
                    }}
                    transition={{ type: "spring", stiffness: 120, damping: 12 }}
                  >
                    <g>
                      <motion.path
                        className="st1"
                        id="G"
                        d="M346.44,468.12v21.55c-10.99-8.24-23.66-15.08-38.02-20.45-7.62-2.86-15.86-4.9-24.64-6.25-9.13-1.56-18.86-2.39-29.26-2.39-20.43,0-39.24,3.7-56.44,11.05-17.22,7.37-31.97,17.52-44.25,30.45-12.3,12.94-21.84,28.02-28.65,45.25-6.81,17.25-10.2,35.76-10.2,55.49,0,.09.01.17.01.26,0,.1-.01.19-.01.29,0,19.4,3.58,37.71,10.76,54.96,7.2,17.23,17.22,32.31,30.08,45.25,12.86,12.93,28.09,23.08,45.66,30.45,17.59,7.34,36.8,11.03,57.59,11.03.92,0,1.77-.11,2.68-.12,1.01.02,1.98.12,3,.12h1.13c1.18,0,2.22-.07,3.18-.19,19.03-.48,37-3.97,53.8-10.72v-76.64c-.09.09-.18.18-.27.27-7.94,7.54-16.83,13.2-26.66,16.97-9.83,3.77-20.22,5.66-31.19,5.66-4.5,0-8.89-.4-13.22-1.03h0c-6.25-.91-12.35-2.4-18.27-4.63-10.04-3.77-18.84-9.43-26.38-16.97-15.81-15.02-23.74-33.26-23.81-54.69.03-10.28,1.91-19.82,5.57-28.63.31-.75.64-1.49.98-2.22,3.96-8.67,9.68-16.63,17.26-23.83,7.55-7.17,16.34-12.74,26.38-16.71,10.02-3.95,20.5-5.92,31.49-5.92,22.69,0,41.97,7.54,57.85,22.62,7.58,7.2,13.3,15.16,17.27,23.83.34.74.67,1.48.98,2.22,3.7,8.89,5.59,18.51,5.59,28.9v107.75c0,21.2-7.96,39.33-23.85,54.41-15.51,15.46-34.79,23.17-57.85,23.17-15.14,0-28.76-3.6-40.86-10.76l-49.35,46.32c12.86,9.34,26.85,16.53,41.99,21.55,15.12,5.02,31.19,7.54,48.22,7.54,20.78,0,40.26-3.77,58.43-11.31,18.14-7.54,34.03-17.78,47.64-30.71,13.62-12.91,24.31-28.02,32.06-45.25,7.73-17.23,11.63-35.56,11.63-54.96v-242.99h-68.07Z"
                        fill={
                          hoveredLetter === "G" ? "#0FEDED" : originalColors.dim
                        }
                        stroke={animationDone1.G ? "none" : "#0FEDED"}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: "#0FEDED",
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() => handleAnimationComplete("G")}
                        onMouseEnter={() => setHoveredLetter("G")}
                      />
                    </g>
                    <rect
                      x="90"
                      y="475"
                      width="275"
                      height="280"
                      fill="transparent"
                      style={{ cursor: "pointer" }}
                      onMouseEnter={() => setHoveredLetter("G")}
                      onMouseLeave={() => setHoveredLetter(null)}
                    />
                    <g>
                      <motion.path
                        className="st2"
                        id="A2"
                        d="M595.13,468.11v21.55c-10.99-8.24-23.66-15.08-38.02-20.45-14.38-5.39-30.84-8.09-49.35-8.09-20.8,0-40,3.68-57.59,11.05-17.57,7.37-32.8,17.49-45.66,30.43-12.86,12.93-22.88,28.02-30.08,45.27-7.18,17.23-10.76,35.73-10.76,55.49s3.58,37.71,10.76,54.96c7.2,17.23,17.22,32.31,30.08,45.25,12.86,12.93,28.09,23.08,45.66,30.45,17.59,7.34,36.8,11.03,57.59,11.03.92,0,1.77-.11,2.68-.12,1.01.02,1.98.12,3,.12,20.66,0,40.04-3.65,58.12-10.91v-76.64c-.09.09-.18.18-.27.27-7.94,7.54-16.83,13.2-26.66,16.97-9.83,3.77-20.22,5.66-31.19,5.66-4.5,0-8.89-.4-13.22-1.03h0c-6.25-.91-12.35-2.4-18.27-4.63-10.04-3.77-18.84-9.43-26.39-16.97-15.88-15.08-23.82-33.21-23.82-54.41s7.94-39.88,23.82-54.96c7.55-7.17,16.34-12.74,26.39-16.71,10.02-3.95,20.5-5.92,31.49-5.92,22.69,0,41.97,7.54,57.85,22.62,15.88,15.08,23.85,33.41,23.85,54.96v141.69h68.07v-276.93h-68.07Z"
                        fill={
                          hoveredLetter === "A2"
                            ? "#1900DA"
                            : originalColors.dim
                        }
                        stroke={animationDone1.A2 ? "none" : "#1900DA"}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: "#1900DA",
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() =>
                          handleAnimationComplete("A2")
                        }
                        onMouseEnter={() => setHoveredLetter("A2")}
                      />
                    </g>
                    <g>
                      <motion.path
                        className="st4"
                        id="R"
                        d="M784.83,468.66c13.41-5.39,28.65-8.09,45.66-8.09v64.65c-22.69,0-41.97,7.56-57.87,22.65-15.88,15.81-23.82,34.11-23.82,54.94v142.24h-68.07v-276.93h68.07v21.02c10.6-8.26,22.6-15.08,36.03-20.48Z"
                        fill={
                          hoveredLetter === "R" ? "#D70A84" : originalColors.dim
                        }
                        stroke={animationDone1.R ? "none" : "#D70A84"}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: "#D70A84",
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() => handleAnimationComplete("R")}
                        onMouseEnter={() => setHoveredLetter("R")}
                      />

                    </g>
                  </motion.g>

                  {/* ROW 3 */}

                  <motion.g
                    animate={{
                      y:
                        hoveredLetter === "A1" ||
                          hoveredLetter === "A2" ||
                          hoveredLetter === "N" ||
                          hoveredLetter === "R" ||
                          (hoveredLetter === "K" && isMobile) ||
                          (hoveredLetter === "G" && isMobile)
                          ? contentHeight
                          : 0,
                    }}
                    transition={{ type: "spring", stiffness: 120, damping: 12 }}
                  >
                    <g>
                      <motion.path
                        className="st7"
                        id="O1"
                        d="M449.26,762.55c20.78,0,40.26,3.68,58.43,11.05,18.14,7.37,34.03,17.49,47.65,30.43,13.62,12.93,24.31,28.02,32.06,45.27,7.73,17.23,11.63,35.73,11.63,55.49s-3.9,37.71-11.63,54.96c-7.76,17.23-18.44,32.31-32.06,45.25-13.62,12.93-29.5,23.08-47.65,30.45-18.17,7.34-37.65,11.03-58.43,11.03s-40.28-3.68-58.45-11.03c-18.14-7.37-34.03-17.52-47.65-30.45-13.62-12.93-24.31-28.02-32.06-45.25-7.76-17.25-11.61-35.56-11.61-54.96s3.86-38.26,11.61-55.49c7.76-17.25,18.44-32.34,32.06-45.27,13.62-12.93,29.5-23.06,47.65-30.43,18.17-7.37,37.63-11.05,58.45-11.05ZM449.26,827.2c-22.69,0-41.99,7.54-57.87,22.62-15.88,15.08-23.82,33.41-23.82,54.96s7.94,39.33,23.82,54.41c7.55,7.54,16.34,13.2,26.38,16.97,10.02,3.77,20.5,5.66,31.49,5.66s21.35-1.89,31.19-5.66c9.83-3.77,18.72-9.43,26.66-16.97,15.88-15.08,23.85-33.21,23.85-54.41s-7.96-39.88-23.85-54.96c-16.64-15.08-35.92-22.62-57.85-22.62Z"
                        fill={
                          hoveredLetter === "O1"
                            ? "#ED2100"
                            : originalColors.dim
                        }
                        stroke={animationDone1.O1 ? "none" : "#EA381D"}
                        strokeWidth="2"
                        initial={{
                          pathLength: 0,
                          fill: "none",
                          fillOpacity: 0,
                        }}
                        animate={{
                          pathLength: 1,
                          fill: "#ED2100",
                          fillOpacity: 1,
                        }}
                        transition={{
                          pathLength: { duration: 2, ease: "easeInOut" },
                          fill: { duration: 0.1, delay: 2 },
                          fillOpacity: { duration: 1, delay: 2 },
                        }}
                        onAnimationComplete={() =>
                          handleAnimationComplete("O1")
                        }
                        onMouseEnter={() => setHoveredLetter("O1")}
                      />
                    </g>


                    <motion.path
                      className="st3"
                      id="O2"
                      d="M680.72,762.55c20.78,0,40.26,3.68,58.43,11.05,18.14,7.37,34.03,17.49,47.65,30.43,13.62,12.93,24.31,28.02,32.06,45.27,7.73,17.23,11.63,35.73,11.63,55.49s-3.9,37.71-11.63,54.96c-7.76,17.23-18.44,32.31-32.06,45.25-13.62,12.93-29.5,23.08-47.65,30.45-18.17,7.34-37.65,11.03-58.43,11.03s-40.28-3.68-58.45-11.03c-18.14-7.37-34.03-17.52-47.65-30.45-13.62-12.93-24.31-28.02-32.06-45.25-7.76-17.25-11.61-35.56-11.61-54.96s3.86-38.26,11.61-55.49c7.76-17.25,18.44-32.34,32.06-45.27,13.62-12.93,29.5-23.06,47.65-30.43,18.17-7.37,37.63-11.05,58.45-11.05ZM680.72,827.2c-22.69,0-41.99,7.54-57.87,22.62-15.88,15.08-23.82,33.41-23.82,54.96s7.94,39.33,23.82,54.41c7.55,7.54,16.34,13.2,26.38,16.97,10.02,3.77,20.5,5.66,31.49,5.66s21.35-1.89,31.19-5.66c9.83-3.77,18.72-9.43,26.66-16.97,15.88-15.08,23.85-33.21,23.85-54.41s-7.96-39.88-23.85-54.96c-16.64-15.08-35.92-22.62-57.85-22.62Z"
                      fill={
                        hoveredLetter === "O2" ? "#7A0708" : originalColors.dim
                      }
                      stroke={animationDone1.O2 ? "none" : "#7A0708"}
                      strokeWidth="2"
                      initial={{ pathLength: 0, fill: "none", fillOpacity: 0 }}
                      animate={{
                        pathLength: 1,
                        fill: "#7A0708",
                        fillOpacity: 1,
                      }}
                      transition={{
                        pathLength: { duration: 2, ease: "easeInOut" },
                        fill: { duration: 0.1, delay: 2 },
                        fillOpacity: { duration: 1, delay: 2 },
                      }}
                      onAnimationComplete={() => handleAnimationComplete("O2")}
                      onMouseEnter={() => {
                        setHoveredLetter("O2");
                      }}
                      onMouseLeave={() => {
                        setHoveredLetter(null);
                      }}
                    />
                  </motion.g>

                  <g className="st5">
                    <path
                      className="st8"
                      d="M717.71,30.28c.75,0,1.36-.61,1.36-1.36s-.61-1.36-1.36-1.36c-4.16,0-7.54-3.38-7.54-7.54s3.38-7.54,7.55-7.54c.03,0,.15.01.16.01.71,0,1.24-.45,1.36-1.1.91-4.66,5.01-8.04,9.77-8.04,5.05,0,9.3,3.79,9.89,8.8.05.43.31.82.69,1.03s.86.23,1.25.04c1.03-.49,2.12-.75,3.25-.75,3.31,0,6.21,2.12,7.2,5.28.22.69.94,1.09,1.64.91.48-.12.86-.18,1.22-.18,2.72,0,4.92,2.21,4.92,4.92s-2.21,4.92-4.92,4.92c-.75,0-1.36.61-1.36,1.36s.61,1.36,1.36,1.36c4.21,0,7.63-3.42,7.63-7.63s-3.42-7.63-7.63-7.63c-.23,0-.46.01-.71.04-1.63-3.67-5.26-6.04-9.36-6.04-.95,0-1.87.14-2.78.39-1.41-5.53-6.41-9.52-12.27-9.52s-10.64,3.79-12.17,9.17c-5.26.43-9.39,4.85-9.39,10.21-.03,5.65,4.56,10.24,10.23,10.24h0Z"
                    />

                    {/* leaf */}
                    {/*   */}
                    <motion.g
                      animate={{
                        y:
                          hoveredLetter === "A1" ||
                            hoveredLetter === "A2" ||
                            hoveredLetter === "N" ||
                            hoveredLetter === "R" ||
                            (hoveredLetter === "K" && isMobile) ||
                            (hoveredLetter === "G" && isMobile)
                            ? contentHeight
                            : 0,
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 120,
                        damping: 12,
                      }}
                    >
                      <motion.g
                        animate={{
                          scale: [1, 1.1, 1], // scale up and down
                          rotate: [0, -35, 0], // move right and back
                        }}
                        transition={{
                          duration: 2, // total cycle time
                          repeat: Infinity, // loop forever
                          ease: "easeInOut", // smooth movement
                        }}
                        style={{
                          width: 80,
                          height: 80,
                          backgroundColor: "deepskyblue",
                          borderRadius: "20px",
                        }}
                      >
                        <path
                          className="st8"
                          d="M928.94,914.2c-.84,0-1.68-.26-2.4-.77l-5.73-4.04c-1.06-.75-1.32-2.22-.57-3.28.75-1.06,2.22-1.32,3.28-.57l4.98,3.51.49-4.65c.1-.98.81-1.8,1.77-2.04l26.66-6.74c-1.31-3.52-.54-7.5,2.05-10.27l3.33-3.58-2.94-.8c-4.13-1.13-7.33-4.32-8.48-8.41l-16.95,6.87c-.98.4-2.1.09-2.75-.74-.65-.84-.66-2-.03-2.85l16.85-22.75c-5.29-1.71-9-6.63-9.13-12.21l-.08-3.31-3.06,2.35c-.44.34-.91.65-1.39.93-1.13.65-2.57.26-3.22-.86-.65-1.13-.26-2.57.86-3.22.3-.18.6-.37.88-.59l3.89-2.99c1.25-.96,2.92-1.14,4.35-.46,1.43.68,2.34,2.09,2.38,3.67l.1,4.37c.09,3.76,2.7,7.04,6.36,7.98,1.34.34,2.41,1.33,2.87,2.64.47,1.32.25,2.78-.58,3.9l-12.31,16.62,9.75-3.95c1.13-.46,2.41-.4,3.49.17,1.09.57,1.88,1.58,2.15,2.79.61,2.67,2.64,4.78,5.29,5.51l3.79,1.04c1.42.39,2.51,1.47,2.92,2.89.4,1.42.04,2.91-.96,3.99l-3.94,4.23c-1.44,1.54-1.81,3.79-.96,5.71.51,1.14.48,2.44-.06,3.56-.54,1.1-1.53,1.91-2.72,2.21l-25.67,6.49-.42,3.92c-.16,1.49-1.06,2.75-2.43,3.36-.56.25-1.15.38-1.73.38Z"
                        />
                        <path
                          className="st8"
                          d="M916.04,905.5c-.47,0-.94-.14-1.36-.43l-5.73-4.04-20.69-5.92c-1.44-.41-2.52-1.52-2.9-2.97-.37-1.45.04-2.94,1.09-4l2.79-2.79-10.87-23.64c-.61-1.33-.49-2.85.32-4.06.81-1.22,2.2-1.9,3.63-1.86l1.78.07,1.49-10.4c.21-1.46,1.15-2.68,2.5-3.25,1.36-.58,2.88-.4,4.08.46l7.79,5.62,2.31-1.87c1.08-.87,2.52-1.15,3.85-.74,1.33.41,2.36,1.45,2.77,2.78l2.95,9.77,5.18-19.89c.36-1.37,1.37-2.45,2.71-2.9,1.34-.45,2.81-.2,3.92.68,1.03.81,2.26,1.36,3.56,1.58,1.28.22,2.14,1.44,1.92,2.72-.22,1.28-1.43,2.15-2.72,1.92-1.81-.31-3.53-1.01-5.02-2.04l-7.09,27.23c-.27,1.02-1.18,1.74-2.24,1.76-1,.03-2-.66-2.3-1.67l-5.15-17.03-3.09,2.49c-.83.67-2,.7-2.86.08l-8.53-6.16-1.67,11.62c-.17,1.19-1.24,2.03-2.42,2.02l-3.02-.11,11.19,24.34c.41.9.22,1.96-.48,2.65l-3.31,3.3,20.2,5.78c.25.07.49.19.71.34l6.06,4.27c1.06.75,1.32,2.22.57,3.28-.46.65-1.19,1-1.93,1Z"
                        />
                        <path
                          className="st8"
                          d="M902.75,916.36c-.34,0-.69-.07-1.02-.23-1.17-.56-1.67-1.97-1.11-3.14l26.15-54.66c.56-1.17,1.97-1.67,3.14-1.11,1.17.56,1.67,1.97,1.11,3.14l-26.15,54.66c-.4.85-1.25,1.34-2.13,1.34Z"
                        />
                        <path
                          className="st8"
                          d="M912.17,897.06c-.9,0-1.74-.52-2.13-1.36l-13.98-29.92c-.55-1.18-.04-2.58,1.14-3.13,1.18-.55,2.58-.04,3.13,1.14l13.16,28.17,30.19-7.43c1.26-.31,2.54.46,2.85,1.73.31,1.26-.46,2.54-1.73,2.85l-32.07,7.89c-.19.05-.38.07-.56.07Z"
                        />
                      </motion.g>
                      <motion.g
                        animate={{
                          scale: [1, 1.1, 1], // scale up and down

                          rotate: [0, 35, 0], // move right and back
                        }}
                        transition={{
                          duration: 2, // total cycle time
                          repeat: Infinity, // loop forever
                          ease: "easeInOut", // smooth movement
                        }}
                        style={{
                          width: 80,
                          height: 80,
                          backgroundColor: "deepskyblue",
                          borderRadius: "20px",
                        }}
                      >
                        <path
                          className="st8"
                          d="M949.98,976.59c-.8,0-1.51-.58-1.66-1.4-.16-.92.45-1.79,1.37-1.95l2.7-.47-1.23-1.52c-.44-.55-.5-1.32-.14-1.92l7.61-12.76c-1.82-.99-3-2.87-3.07-4.98l-.07-2.09-.93.53c-2.06,1.17-4.53,1.24-6.63.22l-3.8,8.97c-.29.69-1.01,1.1-1.76,1.01-.75-.1-1.34-.68-1.45-1.42l-2.24-15.05c-2.79,1.2-6.11.64-8.34-1.49l-.8-.76-.18,1.39c-.04.33-.11.65-.19.96-.24.9-1.16,1.43-2.06,1.19-.9-.24-1.43-1.16-1.19-2.06.05-.17.08-.35.11-.53l.35-2.7c.13-1.01.81-1.85,1.78-2.19.96-.34,2.02-.11,2.76.59l1.75,1.67c1.39,1.33,3.52,1.57,5.18.58.77-.45,1.71-.49,2.52-.11.81.39,1.38,1.15,1.51,2.04l1.49,10.04,1.76-4.15c.31-.73.91-1.28,1.67-1.52.76-.24,1.58-.13,2.25.29,1.17.73,2.65.76,3.85.08l1.9-1.08c.83-.47,1.82-.48,2.65-.01.83.46,1.35,1.31,1.38,2.26l.11,3.2c.04,1.02.67,1.92,1.63,2.28.75.29,1.33.89,1.59,1.65.26.75.17,1.57-.23,2.25l-7.39,12.4,1.21,1.5c.61.75.77,1.74.43,2.64-.34.9-1.11,1.54-2.06,1.71l-3.83.66c-.1.02-.19.02-.29.02Z"
                        />
                        <path
                          className="st8"
                          d="M930.69,984.04c-.47,0-.94-.13-1.37-.38-.83-.49-1.33-1.36-1.33-2.32v-1.93s-13.3-4.92-13.3-4.92c-.88-.33-1.52-1.07-1.71-2-.18-.92.12-1.86.81-2.5l.48-.44-3.29-4.4c-.57-.76-.7-1.74-.34-2.62.36-.88,1.13-1.5,2.07-1.65l4.98-.81.15-1.36c.1-.89.63-1.67,1.42-2.09.79-.42,1.74-.42,2.53,0l3.82,2.05-5.1-8.69c-.46-.79-.49-1.74-.09-2.56.41-.82,1.19-1.37,2.1-1.48.66-.08,1.29-.32,1.84-.71.76-.54,1.81-.36,2.35.4.54.76.36,1.81-.4,2.35-.73.52-1.55.9-2.41,1.12l7.65,13.03c.38.65.28,1.48-.24,2.02-.52.54-1.34.67-2.01.32l-8.21-4.4-.18,1.64c-.08.75-.66,1.36-1.41,1.48l-5.15.83,3.54,4.72c.52.69.43,1.66-.2,2.24l-.78.73,13.37,4.95c.66.25,1.1.88,1.1,1.58v1.96s9.63-5.35,9.63-5.35c.16-.09.34-.15.53-.19l4.05-.7c.92-.16,1.79.46,1.95,1.37.16.92-.46,1.79-1.37,1.95l-3.77.65-10.39,5.77c-.41.23-.86.34-1.31.34Z"
                        />
                        <path
                          className="st8"
                          d="M944.92,986.78c-.69,0-1.34-.43-1.59-1.12l-11.19-31.72c-.31-.88.15-1.84,1.03-2.15.88-.31,1.84.15,2.15,1.03l11.19,31.72c.31.88-.15,1.84-1.03,2.15-.19.07-.37.1-.56.1Z"
                        />
                        <path
                          className="st8"
                          d="M941.04,975.51c-.19,0-.39-.03-.57-.1l-17.23-6.26c-.87-.32-1.33-1.28-1.01-2.16.32-.87,1.28-1.33,2.16-1.01l15.93,5.78,8.78-14.5c.48-.8,1.52-1.05,2.31-.57.8.48,1.05,1.52.57,2.31l-9.49,15.68c-.31.52-.86.81-1.44.81Z"
                        />
                      </motion.g>
                    </motion.g>


                    {/* plane component============ */}
                    <path
                      className="st801"
                      d="M748.34,37.18c-.58,0-1.15.07-1.71.19-1.17-3.91-4.79-6.68-8.99-6.68s-7.73,2.69-8.95,6.55c-3.8.45-6.76,3.69-6.76,7.63,0,.75.61,1.36,1.36,1.36s1.36-.61,1.36-1.36c0-2.74,2.23-4.97,4.93-4.97.01,0,.14.01.15.01.69.03,1.25-.45,1.37-1.1.61-3.12,3.37-5.41,6.56-5.41,3.4,0,6.25,2.54,6.63,5.91.05.43.31.81.69,1.03s.84.23,1.25.04c.68-.33,1.4-.49,2.13-.49,2.19,0,4.09,1.4,4.74,3.48.22.72.98,1.11,1.7.9s1.11-.99.9-1.7c-1.02-3.23-3.97-5.39-7.35-5.39h0Z"
                    />

                    <path
                      className="st801"
                      d="M749.87,139.44l-2.57-17.54,1.24-3.34c1.18-3.19-.34-5.68-1.66-6.9v-9.96l15-3.18c.65-.14,1.1-.72,1.07-1.39s-.53-1.21-1.2-1.29l-14.87-1.78v-.49l17.31-10.8c.56-.35.79-1.06.54-1.67s-.9-.96-1.55-.81l-18.87,4.16s-.03.01-.04.01c-.42-.52-.87-.99-1.34-1.44l10.85-14.93c.39-.54.34-1.28-.14-1.75s-1.21-.54-1.75-.15l-16.15,11.52c-.24.18-.39.43-.49.71-.76-.29-1.52-.53-2.3-.73l-2.68-18.69c-.1-.65-.64-1.14-1.3-1.17-.71-.03-1.24.43-1.37,1.09l-3.9,18.77c-1.06.27-2.04.61-2.95,1.01l-17.54-12.52c-.54-.39-1.29-.33-1.75.15-.48.48-.53,1.22-.14,1.75l12.12,16.68c-.22.31-.42.62-.61.95l-13.34-2.68-.22-3.04c0-.11-.03-.2-.05-.3l-6.23-20.12c0-1.2.03-7.27,0-12.61-.04-5.34-2.8-9.97-3.76-11.42l.2-3.8h.45c.9,0,1.75-.41,2.34-1.1l5.11-6.14c.1-.11.16-.23.24-.35.3-.24.49-.61.49-1.02,0-.07-.03-.12-.04-.19.03-.15.04-.31.04-.46v-4.82c0-1.73-1.37-3.14-3.06-3.14h-5.39c1.66-3.15,3.69-9.68-2.36-22.14-.26-.54-.84-.84-1.44-.75-.6.1-1.05.57-1.13,1.17-.27,2.13-1.68,3.95-4.18,5.43-.42.26-.86.49-1.3.73-1.92,1.05-3.88,2.13-5.37,4.25-2.13,3.07-2.32,7.84-.75,11.3h-3.42c-.82,0-1.59.33-2.17.92-.58.61-.91,1.44-.9,2.3.03.82-.03,1.86-.07,2.77-.08,1.82-.11,2.58.11,3.14.03.08.07.15.11.22.14.2,3.22,5.04,4.55,6.74.58.73,1.45,1.15,2.38,1.15h1.02l.31,3.44-3.08.34c-2.2.24-3.79,2.23-3.55,4.43.11.98.56,1.87,1.29,2.53-.56.8-.82,1.77-.71,2.74.11.98.56,1.87,1.29,2.53-.54.77-.82,1.74-.71,2.74.12,1.14.72,2.12,1.58,2.76-.33.62-.48,1.36-.39,2.11.2,1.87,1.81,3.27,3.65,3.27.14,0,.27-.01.41-.03l2.34-.26.45,4.84c-.12.86-.41,4.05.65,11.98,1.03,7.77,3.36,20.69,3.98,24.1-2.53,1.87-10.55,8.58-10.55,18.34,0,2.16-.08,4.14-.15,5.88-.27,6.85-.48,11.8,5.79,12.93,2.21.39,3.42.65,4.08.81.26,2.72,1.1,11.82,1.41,15.58.15,1.77-.27,2.92-.75,4.25-.6,1.67-1.29,3.56-.72,6.56.14.73.86,1.22,1.59,1.09.73-.14,1.22-.86,1.09-1.59-.43-2.27.05-3.6.61-5.13.3-.81.6-1.7.77-2.74,4.21-1.86,25.82-11.84,30.97-22.07.34-.67.07-1.48-.6-1.82-.68-.34-1.48-.07-1.82.6-4.31,8.57-22.53,17.54-28.44,20.27-.31-3.75-1.05-11.65-1.34-14.74,13.75-2.34,19.04-16.27,20.69-22.13l2.35,2.58c.49.53,1.3.6,1.86.15l1.98-1.6,30.02,21.92c-2.38,3.86-11.87,17.78-27.97,23.38-.71.24-1.09,1.02-.84,1.73.19.56.72.91,1.28.91.15,0,.3-.03.45-.08,17.22-5.99,26.99-20.54,29.46-24.61l4.6,1.85c4.82,2.32,11.29,6.48,13.09,12.69.88,3.04,1.6,6.42,2.15,10.05.1.68.68,1.15,1.34,1.15.07,0,.14,0,.2-.01.75-.11,1.25-.8,1.14-1.53-.56-3.75-1.3-7.25-2.21-10.42-2.02-6.9-8.67-11.45-13.85-14.05h0ZM725.15,80.13c.8-.18,1.62-.27,2.43-.31v5.77c-2.38-.05-4.54.19-6.49.75v-4.81c1.2-.58,2.54-1.07,4.06-1.4ZM744.17,98.43v4.58s-.05-.08-.1-.11c-1.56-1.14-2.74-3.79-3.07-4.71-.01-.04-.04-.07-.07-.11-.03-.07-.08-.14-.12-.2-.07-.1-.14-.18-.23-.26-.03-.03-.04-.07-.08-.1-3.76-2.7-10.4-7.24-10.47-7.29-.31-.22-.71-.29-1.07-.2s-.69.33-.87.65c-.03.05-3.07,5.3-10.7,7.39-.01,0-.03.01-.04.01-.04.01-.07.04-.11.05-.12.04-.22.11-.33.18-.03.01-.04.03-.07.04l-4.55,3.95v-1.07c.01-.24.37-5.81,4.44-9.52,2.73-2.49,6.55-3.63,11.45-3.4.16.01,12.66-.27,15.99,10.12h0ZM729.84,119.61h-.05c-3.41-.05-5.32-2.47-7.74-5.54-.43-.54-.87-1.1-1.32-1.66-1.68-2.05-2.49-4.73-2.2-7.35l.5-4.62c5.91-1.85,9.21-5.34,10.62-7.19,1.93,1.33,5.96,4.1,8.77,6.11.08,1.22.34,4.1.99,8.69-1.2,3.48-4.9,11.55-9.58,11.55h0ZM718.37,87.4c-1.26.62-2.43,1.39-3.46,2.34-.69.62-1.28,1.3-1.81,1.98.34-1.17.83-2.45,1.49-3.72.07-.1.11-.2.16-.31.86-1.53,2.04-3.06,3.61-4.35v4.06ZM712.33,105.32s.1.03.14.03c.31,0,.64-.11.9-.34l2.69-2.34-.22,2.08c-.27,2.51.23,5.05,1.41,7.27v5.62l-4.9-3.57v-8.75h-.01ZM719.95,115.79c2.51,3.19,5.12,6.47,9.79,6.53h.1c1.49,0,2.87-.5,4.1-1.29v8.83l-14-10.23v-3.84h.01ZM736.67,118.62c.23-.26.43-.53.65-.8l3.48,17.05-4.13-3.02v-13.23ZM746.92,138.08c-1.25-.52-2.27-.9-2.93-1.11l-4.47-21.92c-.03-.14-.1-.24-.15-.37,1.7-3.02,2.62-5.84,2.7-6.1.07-.19.08-.41.05-.61-.19-1.36-.35-2.54-.48-3.6.26.26.53.49.81.71.24.18.52.26.8.26.34,0,.65-.15.9-.39v7.34c0,.43.22.86.58,1.11.23.16,2.19,1.66,1.24,4.21l-1.36,3.67c-.08.22-.11.45-.07.67l2.36,16.15ZM753.29,97.56l-6.4,1.36v-2.12l6.4.76ZM756.08,84.63l-9.18,5.73v-.67c0-.12-.01-.24-.05-.37-.24-.88-.58-1.7-.98-2.46l10.21-2.24ZM744.17,89.89v2.72c-1.17-1.51-2.55-2.7-3.99-3.63v-4.75c1.79,1.45,3.3,3.31,3.99,5.66ZM740.8,81.3c-.96-.68-1.97-1.26-2.97-1.77l8.83-6.3-5.85,8.07ZM737.46,82.42v5.13c-2.73-1.18-5.41-1.64-7.16-1.82v-5.77c1.44.18,2.88.54,4.31,1.11.91.35,1.89.8,2.85,1.34ZM728.69,67.05l1.45,10.13c-1.2-.12-2.38-.11-3.55,0l2.09-10.13ZM708.44,73.25l9.67,6.9c-1.1.73-2.06,1.55-2.89,2.43l-6.78-9.33ZM710.28,92.02l-9.16-5.88,10.43,2.09c-.57,1.33-.99,2.62-1.28,3.79ZM676.07,4.75c1.1-1.59,2.72-2.49,4.44-3.42.46-.26.92-.5,1.37-.77,1.9-1.11,3.34-2.47,4.28-4.01,4.55,11.06,1.56,15.93.38,17.86-.03.04-.04.05-.05.1h-10.28c-1.85-2.5-1.94-7.14-.14-9.75ZM669.33,17.64c0-.18.07-.29.12-.33.04-.04.12-.1.22-.1h25.32c.19,0,.34.19.34.42v4.13h-26.12c.01-.38.03-.79.05-1.14.04-.98.1-2.06.07-2.99ZM673.45,28.9c-.72-.91-2.04-2.88-3.04-4.41h23.39l-3.67,4.41c-.07.08-.15.12-.24.12h-16.16c-.12,0-.2-.04-.27-.12h0ZM677.44,31.74h9.28l-.2,3.82c-.04.15-.04.31-.03.46l-1.63,30.67c-.03.54-.26,1.05-.65,1.43-.39.37-.91.58-1.45.58-1.1,0-2.01-.83-2.12-1.93l-.8-8.8c1.63-.53,2.72-2.15,2.53-3.9-.04-.41-.16-.8-.33-1.17,1.48-.72,2.42-2.32,2.23-4.05-.11-1.01-.58-1.89-1.29-2.53.57-.8.81-1.77.71-2.74-.11-.98-.56-1.87-1.29-2.53.54-.77.81-1.74.71-2.74-.24-2.2-2.21-3.78-4.43-3.55l-.95.11-.27-3.14ZM674.51,55.9c-.54.05-1.01-.33-1.06-.86s.33-1.01.84-1.06c.75-.08,1.29-.75,1.2-1.49s-.76-1.29-1.49-1.2l-.3.03c-.71.08-1.34-.43-1.43-1.14s.43-1.34,1.14-1.43c.69-.08,1.21-.67,1.21-1.34,0-.05,0-.1-.01-.15-.08-.75-.73-1.28-1.49-1.2-.34.04-.68-.05-.95-.27s-.43-.53-.48-.87.05-.68.27-.95.53-.43.87-.48c.69-.08,1.21-.67,1.21-1.34,0-.05,0-.1-.01-.15-.08-.75-.75-1.29-1.49-1.2-.35.04-.68-.05-.95-.27s-.43-.53-.48-.87c-.08-.71.43-1.34,1.14-1.43l4.1-.45c.1.01.18.04.29.03.12-.01.22-.05.33-.1l2.01-.22c.71-.07,1.34.43,1.43,1.14s-.43,1.34-1.14,1.43l-3.41.24c-.75.05-1.3.71-1.25,1.45.05.72.65,1.26,1.36,1.26h.1l3.45-.24s.01,0,.03-.01h.03c.34-.04.68.05.95.27s.43.53.48.87-.05.68-.27.95-.53.43-.87.48l-3.46.38c-.75.08-1.29.75-1.21,1.49.08.69.67,1.21,1.34,1.21.05,0,.1,0,.15-.01l3.46-.38c.71-.08,1.36.43,1.43,1.14.08.71-.43,1.34-1.14,1.43l-2.11.23h-.01c-.75.08-1.29.75-1.2,1.49.08.75.76,1.29,1.49,1.2.26-.03.5.04.71.2s.33.39.35.65c.05.53-.33,1.01-.86,1.06l-4.28.46ZM680.47,70.82c.68.37,1.45.6,2.3.6,1.25,0,2.43-.48,3.33-1.33.91-.86,1.44-2.01,1.49-3.26l1.37-25.97c.71,1.74,1.32,3.87,1.33,6.11.04,5.95,0,12.78,0,12.8,0,.14.01.27.05.41l6.25,20.17,1.28,17.54c-3.78,9.82-10,22.05-13.75,22.1-.39,0-.71-.12-.95-.45-2.02-2.68.05-13.24,1.85-19.27,0-.01,0-.04.01-.05.01-.04.01-.1.01-.14.01-.12.03-.24,0-.35v-.08c-.03-.16-2.93-15.92-4.12-24.82-.2-1.52-.35-2.84-.46-3.99h0ZM683.04,134.86c-.91-.35-2.51-.65-5.27-1.15-3.76-.68-3.84-2.83-3.56-10.15.07-1.77.15-3.78.15-5.99,0-6.21,3.98-11.15,6.93-13.99-1.3,5.45-2.85,14.19-.31,17.56.77,1.02,1.83,1.56,3.15,1.53,6.26-.1,13.09-15.7,15.97-23.12l3.52,7.61c.45.96.45,2.06,0,3.02l-.8,1.75c-.04.1-.05.19-.08.29,0,.01-.01.04-.03.05,0,.22-3.67,20.37-19.67,22.59h0ZM708.31,115.15l-2.62-2.89.43-.94c.76-1.68.76-3.61-.01-5.28l-4.88-10.55c-.18-.37-.49-.62-.87-.73l-.45-6.17,9.82,6.33c-.12.95-.14,1.53-.14,1.56v17.66l-1.29,1.02Z"
                    />
                    {/* bird */}
                    <g transform="translate(10)">
                      <motion.path
                        animate={{
                          scale: [1, 1.2, 1], // scales up and down
                          y: [0, -10, 0], // moves left and back
                          // rotates and returns smoothly
                        }}
                        transition={{
                          duration: 2,
                          repeat: Infinity,
                          ease: "easeInOut", // smooth easing
                        }}
                        className="st801"
                        d="M777.47,50.98c-5.76-.75-9.11,2.62-10.83,6.04-1.73-3.44-5.09-6.79-10.83-6.04-.75.1-1.26.77-1.17,1.52s.79,1.28,1.52,1.17c7.57-.98,9.07,7.47,9.14,7.84,0,.01.01.03.01.05.01.07.04.14.07.2.04.1.07.19.12.27.04.05.08.1.12.15.07.08.14.15.22.2.05.04.11.07.16.1.1.05.19.08.3.11.04.01.07.03.1.04.07.01.14.01.2.01h.01c.07,0,.15,0,.22-.01.04,0,.07-.03.11-.04.1-.03.19-.05.27-.11.07-.03.12-.07.19-.11.08-.05.14-.12.2-.19.05-.05.1-.11.14-.16.05-.08.08-.16.11-.24.03-.07.05-.14.08-.22,0-.01.01-.03.01-.05.05-.35,1.55-8.8,9.14-7.84.76.11,1.43-.43,1.52-1.17.11-.75-.41-1.43-1.15-1.52h0Z"
                      />
                      <motion.path
                        animate={{
                          scale: [1, 1.2, 1], // scales up and down
                          y: [0, -10, 0], // moves left and back
                          // rotates and returns smoothly
                        }}
                        transition={{
                          duration: 3,
                          repeat: Infinity,
                          ease: "easeInOut", // smooth easing
                        }}
                        className="st801"
                        d="M784.37,34.24c-3.57-.46-5.8,1.33-7.08,3.4-1.29-2.06-3.52-3.86-7.06-3.4-.75.1-1.26.77-1.17,1.52.1.75.76,1.28,1.52,1.17,4.36-.57,5.3,4.13,5.39,4.67,0,.01.01.03.01.05.01.07.04.14.07.2.04.1.07.19.12.27.04.05.08.1.12.15.07.08.14.15.23.22.05.04.11.07.16.1.1.05.2.1.31.12.03.01.05.03.1.04.07.01.14.01.2.01h.03c.07,0,.15,0,.22-.01.04-.01.08-.03.12-.04.1-.03.18-.05.26-.1.07-.04.14-.07.19-.11.07-.05.14-.11.19-.18.05-.05.11-.11.15-.18.05-.08.08-.16.11-.24.03-.07.07-.14.08-.22,0-.01.01-.03.01-.04.1-.54,1.02-5.24,5.38-4.67.75.11,1.43-.43,1.52-1.17.07-.8-.45-1.48-1.2-1.58h0Z"
                      />
                    </g>
                    {/* aeroplane */}

                    <motion.g
                      animate={{
                        y: [500, 0], // moves left and back
                        // rotates and returns smoothly
                      }}
                      transition={{
                        duration: 2,

                        ease: "easeInOut", // smooth easing
                      }}
                    >

                      <path
                        className="st801"
                        d="M510.62,270.22c-.39,0-.76-.15-1.04-.43-.57-.57-.56-1.5.02-2.08,1.08-1.08,2.51-1.67,4.03-1.67s2.96.59,4.03,1.67c.28.28.43.65.43,1.04s-.15.76-.43,1.04c-.57.57-1.51.57-2.08,0-1.08-1.08-2.84-1.08-3.92,0-.28.28-.65.43-1.04.43ZM513.63,267.05c-1.26,0-2.43.49-3.32,1.37-.19.19-.19.48-.02.66.18.17.48.18.66,0,1.47-1.47,3.87-1.47,5.35,0,.18.18.48.18.66,0,.09-.09.14-.2.14-.33s-.05-.24-.14-.33c-.89-.89-2.06-1.37-3.32-1.37Z"
                      />
                      <path
                        className="st801"
                        d="M509.94,269.43c.38.38.99.38,1.37,0,1.28-1.28,3.35-1.28,4.63,0,.38.38.99.38,1.37,0s.38-.99,0-1.37c-2.03-2.03-5.33-2.03-7.35,0-.39.39-.39,1-.02,1.37h0Z"
                      />
                      <path
                        className="st801"
                        d="M548.97,293.65c-2.18,1.55-3.49,4.06-3.53,6.74l-5.85-3.33v-4.01c0-2.74-1.33-5.31-3.56-6.9-.33-.24-.78-.24-1.12,0-2.05,1.45-3.32,3.77-3.51,6.25l-4.88-2.78c-.46-.26-1.05-.11-1.32.36-.26.46-.1,1.05.36,1.32l33.96,19.32v1.91l-26.32-5.93c-3.72-.84-7.54-1.29-11.36-1.35.21-6.12.36-12.04.44-17.19.18-6.67.26-12.16.22-15.45,0-9.61-4.03-14.1-6.44-15.94-1.47-1.07-3.41-1.06-4.82,0-1.16.91-2.2,2.02-3.1,3.33-.3.44-.19,1.04.25,1.33.44.3,1.04.19,1.33-.25.78-1.14,1.69-2.1,2.69-2.87.75-.57,1.73-.56,2.51,0,2.12,1.61,5.67,5.61,5.67,14.41.04,3.21-2.11,58.24-2.39,59.51,0,.03-.04.05-.05.1,0,0-.15.46-.17.57,0,.05-3.56,15.2-4.29,17.29-.76-2.05-4.24-16.75-4.24-16.75-.06-.32-.13-.58-.14-.61,0,0-.19-.69-.24-.78-.45-2.16-2.38-56.22-2.38-59.3,0-2.73.38-5.23,1.07-7.4.16-.5-.12-1.05-.62-1.22s-1.05.11-1.22.62c-.76,2.36-1.15,5.05-1.17,7.98,0,3.03.07,7.95.21,14.59l-9.1,5.17c-.19-2.5-1.47-4.8-3.51-6.25-.33-.24-.78-.24-1.12,0-2.23,1.6-3.55,4.18-3.55,6.9v4s-5.85,3.33-5.85,3.33c-.05-2.69-1.36-5.2-3.53-6.74-.33-.24-.78-.24-1.12,0-2.23,1.6-3.55,4.18-3.55,6.9v4.51l-7.34,4.16c-.3.17-.49.49-.48.84v3.67c0,.3.13.57.35.76.23.18.53.24.82.19l27.51-6.18c2.44-.55,4.95-.93,7.44-1.14.53-.05.92-.5.87-1.04-.05-.53-.51-.93-1.05-.88-2.59.21-5.18.6-7.71,1.17l-26.32,5.91v-1.91s37.27-21.21,37.27-21.21c.14,5.88.3,11.67.48,16.81.8,22.79,1.61,26.27,1.98,27.09l.09.38c.23,1.07.81,3.75,1.51,6.76l-15.48,3.7v-2.36s11.9-6.65,11.9-6.65c.47-.25.63-.85.37-1.31-.26-.46-.85-.63-1.31-.37l-12.39,6.93c-.3.17-.5.5-.5.84v4.13c0,.31.14.59.36.78.23.18.53.24.82.19l16.68-3.96c.78,3.17,1.64,6.43,2.38,8.42.28.75.97,1.24,1.77,1.24.5,0,.98-.21,1.32-.55.19-.19.34-.43.44-.69.76-2.05,4.32-16.83,4.32-16.83l14.03,7.85v2.35s-11.47-2.72-11.47-2.72c-.51-.12-1.05.2-1.16.71-.13.52.2,1.05.71,1.16l12.66,3c.29.07.59,0,.82-.19l.08-.08c.18-.18.28-.42.28-.68v-4.13c0-.34-.19-.68-.5-.84l-15.02-8.41c.39-2.3.95-8.28,1.61-24.77,3.7.05,7.39.49,11,1.29l27.51,6.18c.28.06.59,0,.82-.19l.07-.07c.18-.18.28-.42.28-.68v-3.68c0-.34-.18-.67-.49-.83l-7.33-4.17v-4.51c0-2.74-1.32-5.31-3.55-6.9-.33-.24-.78-.24-1.12,0h0ZM533.29,293.05c0-1.87.79-3.66,2.18-4.88,1.38,1.23,2.19,3.02,2.18,4.88v2.9l-4.36-2.49v-.41ZM489.59,293.05c0-1.87.8-3.65,2.18-4.88,1.38,1.23,2.18,3.01,2.18,4.88v.41l-4.36,2.49v-2.9ZM475.53,303.95v-3.41c0-1.87.8-3.65,2.18-4.88,1.38,1.23,2.18,3.01,2.18,4.88v.93s-2.26,1.3-2.26,1.3l-2.1,1.18ZM551.71,300.55v3.41l-1.7-.96-2.67-1.51v-.92c0-1.87.8-3.67,2.18-4.88,1.39,1.23,2.19,3,2.19,4.88h0Z"
                      />
                      <path
                        className="st801"
                        d="M513.64,352.52c-1,0-1.88-.62-2.24-1.57-.61-1.64-1.36-4.26-2.28-7.99l-16.19,3.84c-.46.09-.9-.02-1.24-.28-.36-.3-.56-.73-.56-1.18v-4.13c0-.52.29-1.01.75-1.28l12.4-6.93c.7-.4,1.59-.15,1.99.56.19.34.24.75.13,1.13-.11.38-.36.69-.7.87l-11.63,6.5v1.43l14.37-3.43c-.65-2.81-1.19-5.27-1.4-6.28l-.09-.37c-.26-.55-1.13-2.48-2-27.19-.17-4.72-.32-10.22-.46-15.97l-36.27,20.64v.99l25.7-5.77c2.57-.58,5.19-.97,7.79-1.18.39-.03.77.09,1.07.34s.49.61.52,1c.03.39-.09.77-.34,1.07s-.61.48-1,.51c-2.5.21-4.98.59-7.38,1.12l-27.51,6.18c-.45.09-.9-.02-1.24-.28-.35-.3-.54-.7-.56-1.14v-3.68c0-.51.27-1.01.74-1.27l7.08-4.02v-4.21c0-2.89,1.41-5.63,3.76-7.31.51-.37,1.2-.37,1.71,0,2.06,1.46,3.4,3.78,3.69,6.31l4.89-2.78v-3.71c0-2.89,1.41-5.63,3.76-7.31.51-.37,1.2-.37,1.71,0,1.95,1.38,3.24,3.48,3.63,5.85l8.18-4.65c-.14-6.7-.2-11.38-.2-14.3.02-2.98.42-5.72,1.2-8.14.26-.77,1.09-1.19,1.85-.95.37.12.68.38.86.73.18.35.21.75.09,1.12-.69,2.15-1.04,4.59-1.05,7.25,0,3.08,1.91,56.39,2.36,59.15.04.11.11.32.24.79,0,0,0,0,0,0,0,0,.05.15.16.66.03.11,2.54,10.71,3.74,15.07,1.19-4.46,3.78-15.49,3.81-15.61.02-.1.18-.62.18-.62l.04-.09c.27-2.27,2.41-55.71,2.37-59.35,0-8.57-3.43-12.46-5.47-14.01-.6-.43-1.32-.43-1.89,0-.96.74-1.83,1.66-2.57,2.75-.45.66-1.36.84-2.03.39-.32-.22-.54-.55-.62-.93-.07-.39,0-.78.23-1.11.92-1.34,2-2.5,3.21-3.45,1.6-1.22,3.78-1.22,5.43-.02,2.49,1.89,6.65,6.53,6.65,16.35.04,3.24-.03,8.59-.22,15.46-.08,4.93-.22,10.69-.42,16.68,3.69.09,7.37.55,10.94,1.35l25.7,5.79v-.99l-33.7-19.18c-.34-.19-.58-.51-.69-.89-.1-.38-.06-.78.14-1.12.4-.7,1.3-.95,2-.55l4.23,2.4c.39-2.37,1.69-4.47,3.63-5.85.51-.37,1.2-.37,1.71,0,2.35,1.68,3.76,4.42,3.76,7.31v3.72s4.9,2.78,4.9,2.78c.28-2.52,1.62-4.84,3.69-6.31.51-.37,1.2-.37,1.71,0,2.35,1.69,3.76,4.42,3.76,7.31v4.21l7.07,4.03c.45.24.74.73.74,1.27v3.68c0,.39-.15.76-.43,1.03l-.12.12c-.35.27-.82.37-1.24.28l-27.5-6.18c-3.42-.76-6.92-1.18-10.41-1.27-.51,12.55-1.03,20.62-1.54,23.99l14.72,8.24c.45.24.75.74.75,1.28v4.13c0,.39-.15.76-.43,1.03l-.11.11c-.35.3-.82.4-1.27.29l-12.66-3c-.38-.09-.7-.32-.91-.65-.21-.34-.27-.74-.18-1.12.18-.78.96-1.27,1.77-1.09l10.86,2.58v-1.42s-13.2-7.38-13.2-7.38c-.7,2.91-3.5,14.4-4.18,16.23-.13.34-.32.64-.56.88-.44.44-1.06.7-1.68.7ZM509.87,341.74l.12.49c.95,3.89,1.75,6.71,2.36,8.36.21.56.74.89,1.31.91l-.45-1.22c-.76-2.06-4.12-16.21-4.26-16.81-.05-.27-.1-.48-.12-.55-.02-.05-.16-.59-.22-.74l-.04-.07v-.05c-.47-2.26-2.39-56.09-2.39-59.4,0-2.76.38-5.3,1.1-7.55.04-.12.03-.24-.03-.35-.06-.11-.15-.19-.27-.23-.24-.08-.5.05-.58.3-.74,2.31-1.13,4.95-1.15,7.83,0,2.95.07,7.72.21,14.58v.3s-10.05,5.71-10.05,5.71l-.06-.79c-.18-2.38-1.38-4.52-3.3-5.88-.16-.12-.37-.12-.53,0-2.1,1.5-3.34,3.93-3.34,6.5v4.3l-6.84,3.89-.02-.85c-.05-2.53-1.29-4.9-3.32-6.34-.16-.12-.37-.12-.53,0-2.1,1.5-3.34,3.93-3.34,6.5v4.8l-7.59,4.31c-.14.08-.23.23-.22.39v3.68c0,.14.06.27.17.37.1.07.25.11.4.08l27.49-6.18c2.44-.55,4.97-.93,7.51-1.15.12-.01.23-.07.31-.16.08-.09.11-.21.1-.33-.01-.12-.07-.24-.16-.32-.09-.08-.21-.11-.34-.11-2.55.2-5.12.59-7.65,1.16l-26.93,6.05v-2.84l38.26-21.77.02.85c.14,6.05.3,11.86.48,16.8.71,20.26,1.45,25.81,1.94,26.9l.12.47c.23,1.08.81,3.76,1.51,6.76l.11.49-16.59,3.96v-3.3l12.15-6.79c.11-.06.18-.15.22-.27.03-.12.02-.24-.04-.35s-.16-.18-.28-.22c-.12-.03-.24-.02-.34.04l-12.4,6.93c-.14.08-.24.24-.24.4v4.13c0,.15.07.29.18.39.1.07.25.11.4.08l17.15-4.07ZM518.61,332.44s-.12.36-.14.47c-.03.13-3.58,15.29-4.31,17.36l-.43,1.23c.33-.02.64-.17.88-.4.14-.14.25-.32.33-.52.74-2,4.26-16.62,4.3-16.76l.16-.65,14.87,8.32v3.29s-12.09-2.87-12.09-2.87c-.24-.06-.5.1-.55.33-.03.13-.01.25.05.36.06.1.16.17.28.2l12.67,3c.14.03.28,0,.38-.08.13-.14.18-.25.18-.37v-4.13c0-.16-.09-.32-.23-.39l-15.34-8.59.06-.35c.53-3.14,1.07-11.45,1.61-24.71l.02-.49h.49c3.72.06,7.46.5,11.11,1.31l27.51,6.18c.13.03.28,0,.4-.1.11-.11.15-.23.15-.35v-3.68c0-.17-.08-.31-.22-.38l-7.6-4.33v-4.8c0-2.57-1.25-4.99-3.34-6.49-.16-.12-.37-.12-.53,0h0c-2.04,1.45-3.28,3.82-3.32,6.34v.85s-6.86-3.89-6.86-3.89v-4.3c0-2.57-1.26-5-3.35-6.49-.16-.12-.37-.12-.53,0-1.92,1.36-3.12,3.5-3.31,5.89l-.06.79-5.57-3.17c-.22-.13-.5-.05-.63.17-.06.1-.07.23-.04.35.03.12.11.22.21.28l34.21,19.47v2.84l-26.93-6.07c-3.67-.83-7.46-1.28-11.25-1.34h-.51s.02-.52.02-.52c.21-6.17.36-12.11.44-17.18.19-6.87.26-12.2.22-15.43,0-9.39-3.91-13.77-6.24-15.55-1.27-.93-2.97-.93-4.21,0-1.12.88-2.13,1.96-2.99,3.22-.07.1-.09.23-.07.35.02.12.09.22.19.28.21.14.49.09.63-.12.81-1.18,1.75-2.18,2.8-2.98.92-.7,2.14-.71,3.11,0,2.2,1.68,5.88,5.82,5.88,14.82.04,3.89-2.15,58.5-2.4,59.62l-.07.18h0ZM552.21,304.82l-5.38-3.05v-1.21c0-2.03.86-3.94,2.35-5.26l.33-.29.33.29c1.5,1.33,2.36,3.24,2.36,5.25v4.27ZM547.84,301.19l3.36,1.91v-2.54c0-1.57-.61-3.07-1.68-4.18-1.07,1.11-1.68,2.61-1.68,4.19v.63ZM475.02,304.81v-4.27c0-2.01.86-3.92,2.35-5.26l.34-.3.34.3c1.49,1.34,2.35,3.25,2.35,5.26v1.22s-5.37,3.05-5.37,3.05ZM477.71,296.36c-1.07,1.12-1.68,2.62-1.68,4.18v2.54l3.36-1.91v-.63c0-1.57-.61-3.07-1.68-4.19ZM538.15,296.82l-5.37-3.06v-.71c0-2.02.86-3.94,2.35-5.26l.34-.3.33.3c1.5,1.35,2.36,3.26,2.35,5.26v3.77ZM533.79,293.17l3.35,1.91v-2.03c0-1.56-.6-3.06-1.68-4.18-1.07,1.11-1.67,2.61-1.67,4.18v.12ZM489.09,296.82v-3.77c0-2.01.86-3.92,2.35-5.26l.34-.3.34.3c1.49,1.34,2.35,3.26,2.35,5.26v.71l-5.37,3.06ZM491.78,288.87c-1.07,1.12-1.68,2.62-1.68,4.18v2.03l3.35-1.91v-.12c0-1.56-.61-3.06-1.68-4.18Z"
                      />
                      {/* line */}
                      <motion.svg clipPath="url(#clip)" initial={{ y: -50 }} animate={{ y: 0 }} transition={{ duration: 1 }}>

                        <motion.g style={{ overflow: "hidden", height: "1200px" }}
                          animate={{ y: [0, 320] }} // numeric interpolation
                          transition={{
                            duration: 5,
                            repeat: Infinity,
                            ease: "linear",
                            repeatType: "loop" // will still jump to 0 at the end
                          }}>
                          <g transform="translate(0,-320)">



                            <path
                              className="st801"
                              d="M491.42,319.45v-3.71c0-.54-.42-.96-.96-.96s-.96.42-.96.96v3.71c0,.54.42.96.96.96.27,0,.5-.11.68-.28.18-.18.29-.41.29-.68Z"
                            />
                            <path
                              className="st801"
                              d="M490.46,320.92c-.82,0-1.47-.65-1.47-1.47v-3.71c0-.82.65-1.47,1.47-1.47s1.47.65,1.47,1.47v3.71c0,.39-.15.76-.44,1.04-.28.28-.64.43-1.03.43ZM490.46,315.28c-.26,0-.46.2-.46.46v3.71c0,.26.2.46.46.46.15,0,.26-.07.32-.13.09-.09.14-.2.14-.33v-3.71c0-.26-.2-.46-.46-.46Z"
                            />
                            <path
                              className="st801"
                              d="M490.45,332.64c.27,0,.5-.11.68-.28s.29-.41.28-.68v-7.35c0-.54-.42-.96-.96-.96-.54,0-.96.42-.96.96v7.35c.02.52.45.96.97.96Z"
                            />
                            <path
                              className="st801"
                              d="M490.45,333.15c-.79,0-1.45-.65-1.48-1.44v-7.37c0-.82.65-1.47,1.47-1.47s1.47.65,1.47,1.47v7.35c.01.37-.14.75-.43,1.03-.27.28-.64.43-1.03.43ZM490.44,323.88c-.26,0-.46.2-.46.46v7.35c0,.24.22.45.47.45.16,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-7.37c0-.26-.2-.46-.46-.46Z"
                            />
                            <path
                              className="st801"
                              d="M479.83,330.91c0-.53-.42-.96-.96-.96-.52,0-.96.42-.96.96v2.4c0,.53.42.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-2.41Z"
                            />
                            <path
                              className="st801"
                              d="M478.87,334.78c-.4,0-.78-.16-1.05-.44-.27-.28-.42-.65-.41-1.04v-2.39c0-.81.66-1.47,1.47-1.47.4,0,.78.16,1.05.44.27.28.42.65.41,1.03v2.4c0,.36-.15.75-.44,1.03-.28.28-.64.43-1.03.43ZM478.87,330.45c-.25,0-.46.21-.46.46v2.4c0,.13.04.24.12.32.19.2.54.12.65,0,.08-.09.13-.2.13-.3v-2.43c.01-.12-.03-.23-.12-.31-.09-.09-.21-.14-.33-.14Z"
                            />
                            <path
                              className="st801"
                              d="M479.56,327.37c.17-.17.29-.41.28-.68v-6.43c0-.54-.42-.96-.96-.96s-.96.42-.96.96v6.43c0,.54.41.96.96.96.27,0,.51-.1.69-.28Z"
                            />
                            <path
                              className="st801"
                              d="M478.86,328.16c-.82,0-1.47-.65-1.47-1.47v-6.43c0-.82.65-1.47,1.48-1.47s1.47.65,1.47,1.47v6.44c.01.37-.14.75-.43,1.03-.28.28-.65.43-1.05.43ZM478.87,319.8c-.26,0-.46.2-.46.46v6.43c0,.39.53.58.79.33h0c.09-.09.13-.2.13-.3v-6.45c0-.26-.2-.46-.46-.46Z"
                            />
                            <path
                              className="st801"
                              d="M537.76,319.46v-3.71c0-.54-.42-.96-.96-.96s-.96.42-.96.96v3.71c0,.54.42.96.96.96.27,0,.5-.11.68-.28.18-.18.29-.43.29-.68Z"
                            />
                            <path
                              className="st801"
                              d="M536.79,320.93c-.82,0-1.47-.65-1.47-1.47v-3.71c0-.82.65-1.47,1.47-1.47s1.47.65,1.47,1.47v3.71c0,.38-.16.76-.44,1.04s-.64.43-1.03.43ZM536.79,315.29c-.26,0-.46.2-.46.46v3.71c0,.26.2.46.46.46.15,0,.26-.07.32-.13.09-.09.14-.21.14-.33v-3.71c0-.26-.2-.46-.46-.46Z"
                            />
                            <path
                              className="st801"
                              d="M536.79,323.36c-.54,0-.96.42-.96.96v7.36c0,.54.41.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-7.36c.02-.55-.41-.98-.95-.97h0Z"
                            />
                            <path
                              className="st801"
                              d="M536.78,333.16c-.82,0-1.47-.65-1.47-1.47v-7.36c0-.82.65-1.47,1.47-1.47.38,0,.76.14,1.04.42.28.28.43.66.43,1.07v7.36c0,.37-.15.75-.44,1.03-.27.27-.64.43-1.03.43ZM536.79,323.87c-.26,0-.46.2-.46.46v7.36c0,.26.19.46.45.46.15,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-7.38c.01-.14-.03-.26-.12-.34-.08-.08-.15-.15-.31-.13h0Z"
                            />
                            <path
                              className="st801"
                              d="M547.42,330.92v2.4c0,.54.42.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-2.4c0-.54-.42-.96-.96-.96-.52-.02-.96.41-.96.96h0Z"
                            />
                            <path
                              className="st801"
                              d="M548.38,334.79c-.82,0-1.47-.65-1.47-1.47v-2.4c0-.4.16-.79.45-1.06.28-.27.63-.4,1.03-.4h0c.81,0,1.45.65,1.45,1.47v2.4c.01.36-.14.75-.43,1.03-.27.28-.64.43-1.03.43ZM548.36,330.47c-.12,0-.22.04-.3.12-.09.09-.14.21-.14.34v2.4c0,.26.2.46.46.46.16,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-2.41c0-.27-.23-.45-.48-.46Z"
                            />
                            <path
                              className="st801"
                              d="M547.42,320.25v6.43c0,.54.42.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-6.43c0-.54-.42-.96-.96-.96-.53,0-.96.41-.96.96h0Z"
                            />
                            <path
                              className="st801"
                              d="M548.38,328.16c-.82,0-1.47-.65-1.47-1.47v-6.44c0-.4.15-.77.43-1.05.28-.27.66-.41,1.03-.41.82,0,1.46.65,1.46,1.47v6.44c.01.36-.14.75-.43,1.03-.27.28-.64.43-1.03.43ZM548.36,319.8c-.12,0-.23.04-.31.12-.09.08-.13.2-.13.33v6.44c0,.26.2.46.46.46.16,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-6.45c0-.27-.21-.46-.47-.46Z"
                            />
                            <path
                              className="st801"
                              d="M489.48,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M489.48,435.85c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM489.48,404.36c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M489.48,624.8c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM489.48,593.3c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM489.48,555.52c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35ZM489.48,530.32c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM489.48,498.83c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM489.48,461.04c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35Z"

                            />


                            <path
                              className="st801"
                              d="M489.48,640.12c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M478.87,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M478.87,429.04c-.74,0-1.35-.6-1.35-1.35v-22.72c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.72c0,.74-.6,1.35-1.35,1.35ZM478.87,400.64c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M478.87,599.4c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM478.87,571c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM478.87,536.93c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35ZM478.87,514.22c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM478.87,485.82c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM478.87,451.75c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M478.87,614.1c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M548.26,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M548.26,429.04c-.74,0-1.35-.6-1.35-1.35v-22.72c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.72c0,.74-.6,1.35-1.35,1.35ZM548.26,400.64c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M548.26,599.4c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM548.26,571c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM548.26,536.93c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35ZM548.26,514.22c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM548.26,485.82c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM548.26,451.75c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M548.26,614.1c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M537.65,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M537.65,435.85c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM537.65,404.36c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M537.65,624.8c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM537.65,593.3c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM537.65,555.52c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35ZM537.65,530.32c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM537.65,498.83c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM537.65,461.04c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35Z"
                            />
                            <path
                              className="st801"
                              d="M537.65,640.12c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                            />
                          </g>

                          <path
                            className="st801"
                            d="M491.42,319.45v-3.71c0-.54-.42-.96-.96-.96s-.96.42-.96.96v3.71c0,.54.42.96.96.96.27,0,.5-.11.68-.28.18-.18.29-.41.29-.68Z"
                          />
                          <path
                            className="st801"
                            d="M490.46,320.92c-.82,0-1.47-.65-1.47-1.47v-3.71c0-.82.65-1.47,1.47-1.47s1.47.65,1.47,1.47v3.71c0,.39-.15.76-.44,1.04-.28.28-.64.43-1.03.43ZM490.46,315.28c-.26,0-.46.2-.46.46v3.71c0,.26.2.46.46.46.15,0,.26-.07.32-.13.09-.09.14-.2.14-.33v-3.71c0-.26-.2-.46-.46-.46Z"
                          />
                          <path
                            className="st801"
                            d="M490.45,332.64c.27,0,.5-.11.68-.28s.29-.41.28-.68v-7.35c0-.54-.42-.96-.96-.96-.54,0-.96.42-.96.96v7.35c.02.52.45.96.97.96Z"
                          />
                          <path
                            className="st801"
                            d="M490.45,333.15c-.79,0-1.45-.65-1.48-1.44v-7.37c0-.82.65-1.47,1.47-1.47s1.47.65,1.47,1.47v7.35c.01.37-.14.75-.43,1.03-.27.28-.64.43-1.03.43ZM490.44,323.88c-.26,0-.46.2-.46.46v7.35c0,.24.22.45.47.45.16,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-7.37c0-.26-.2-.46-.46-.46Z"
                          />
                          <path
                            className="st801"
                            d="M479.83,330.91c0-.53-.42-.96-.96-.96-.52,0-.96.42-.96.96v2.4c0,.53.42.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-2.41Z"
                          />
                          <path
                            className="st801"
                            d="M478.87,334.78c-.4,0-.78-.16-1.05-.44-.27-.28-.42-.65-.41-1.04v-2.39c0-.81.66-1.47,1.47-1.47.4,0,.78.16,1.05.44.27.28.42.65.41,1.03v2.4c0,.36-.15.75-.44,1.03-.28.28-.64.43-1.03.43ZM478.87,330.45c-.25,0-.46.21-.46.46v2.4c0,.13.04.24.12.32.19.2.54.12.65,0,.08-.09.13-.2.13-.3v-2.43c.01-.12-.03-.23-.12-.31-.09-.09-.21-.14-.33-.14Z"
                          />
                          <path
                            className="st801"
                            d="M479.56,327.37c.17-.17.29-.41.28-.68v-6.43c0-.54-.42-.96-.96-.96s-.96.42-.96.96v6.43c0,.54.41.96.96.96.27,0,.51-.1.69-.28Z"
                          />
                          <path
                            className="st801"
                            d="M478.86,328.16c-.82,0-1.47-.65-1.47-1.47v-6.43c0-.82.65-1.47,1.48-1.47s1.47.65,1.47,1.47v6.44c.01.37-.14.75-.43,1.03-.28.28-.65.43-1.05.43ZM478.87,319.8c-.26,0-.46.2-.46.46v6.43c0,.39.53.58.79.33h0c.09-.09.13-.2.13-.3v-6.45c0-.26-.2-.46-.46-.46Z"
                          />
                          <path
                            className="st801"
                            d="M537.76,319.46v-3.71c0-.54-.42-.96-.96-.96s-.96.42-.96.96v3.71c0,.54.42.96.96.96.27,0,.5-.11.68-.28.18-.18.29-.43.29-.68Z"
                          />
                          <path
                            className="st801"
                            d="M536.79,320.93c-.82,0-1.47-.65-1.47-1.47v-3.71c0-.82.65-1.47,1.47-1.47s1.47.65,1.47,1.47v3.71c0,.38-.16.76-.44,1.04s-.64.43-1.03.43ZM536.79,315.29c-.26,0-.46.2-.46.46v3.71c0,.26.2.46.46.46.15,0,.26-.07.32-.13.09-.09.14-.21.14-.33v-3.71c0-.26-.2-.46-.46-.46Z"
                          />
                          <path
                            className="st801"
                            d="M536.79,323.36c-.54,0-.96.42-.96.96v7.36c0,.54.41.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-7.36c.02-.55-.41-.98-.95-.97h0Z"
                          />
                          <path
                            className="st801"
                            d="M536.78,333.16c-.82,0-1.47-.65-1.47-1.47v-7.36c0-.82.65-1.47,1.47-1.47.38,0,.76.14,1.04.42.28.28.43.66.43,1.07v7.36c0,.37-.15.75-.44,1.03-.27.27-.64.43-1.03.43ZM536.79,323.87c-.26,0-.46.2-.46.46v7.36c0,.26.19.46.45.46.15,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-7.38c.01-.14-.03-.26-.12-.34-.08-.08-.15-.15-.31-.13h0Z"
                          />
                          <path
                            className="st801"
                            d="M547.42,330.92v2.4c0,.54.42.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-2.4c0-.54-.42-.96-.96-.96-.52-.02-.96.41-.96.96h0Z"
                          />
                          <path
                            className="st801"
                            d="M548.38,334.79c-.82,0-1.47-.65-1.47-1.47v-2.4c0-.4.16-.79.45-1.06.28-.27.63-.4,1.03-.4h0c.81,0,1.45.65,1.45,1.47v2.4c.01.36-.14.75-.43,1.03-.27.28-.64.43-1.03.43ZM548.36,330.47c-.12,0-.22.04-.3.12-.09.09-.14.21-.14.34v2.4c0,.26.2.46.46.46.16,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-2.41c0-.27-.23-.45-.48-.46Z"
                          />
                          <path
                            className="st801"
                            d="M547.42,320.25v6.43c0,.54.42.96.96.96.27,0,.5-.11.68-.28s.29-.41.28-.68v-6.43c0-.54-.42-.96-.96-.96-.53,0-.96.41-.96.96h0Z"
                          />
                          <path
                            className="st801"
                            d="M548.38,328.16c-.82,0-1.47-.65-1.47-1.47v-6.44c0-.4.15-.77.43-1.05.28-.27.66-.41,1.03-.41.82,0,1.46.65,1.46,1.47v6.44c.01.36-.14.75-.43,1.03-.27.28-.64.43-1.03.43ZM548.36,319.8c-.12,0-.23.04-.31.12-.09.08-.13.2-.13.33v6.44c0,.26.2.46.46.46.16,0,.26-.07.32-.13.09-.09.14-.2.13-.3v-6.45c0-.27-.21-.46-.47-.46Z"
                          />
                          <path
                            className="st801"
                            d="M489.48,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M489.48,435.85c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM489.48,404.36c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M489.48,624.8c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM489.48,593.3c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM489.48,555.52c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35ZM489.48,530.32c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM489.48,498.83c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM489.48,461.04c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35Z"

                          />


                          <path
                            className="st801"
                            d="M489.48,640.12c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M478.87,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M478.87,429.04c-.74,0-1.35-.6-1.35-1.35v-22.72c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.72c0,.74-.6,1.35-1.35,1.35ZM478.87,400.64c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M478.87,599.4c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM478.87,571c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM478.87,536.93c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35ZM478.87,514.22c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM478.87,485.82c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM478.87,451.75c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M478.87,614.1c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M548.26,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M548.26,429.04c-.74,0-1.35-.6-1.35-1.35v-22.72c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.72c0,.74-.6,1.35-1.35,1.35ZM548.26,400.64c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M548.26,599.4c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM548.26,571c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM548.26,536.93c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35ZM548.26,514.22c-.74,0-1.35-.6-1.35-1.35v-22.71c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v22.71c0,.74-.6,1.35-1.35,1.35ZM548.26,485.82c-.74,0-1.35-.6-1.35-1.35v-28.39c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v28.39c0,.74-.6,1.35-1.35,1.35ZM548.26,451.75c-.74,0-1.35-.6-1.35-1.35v-17.04c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v17.04c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M548.26,614.1c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M537.65,366.57c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M537.65,435.85c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM537.65,404.36c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M537.65,624.8c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM537.65,593.3c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM537.65,555.52c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35ZM537.65,530.32c-.74,0-1.35-.6-1.35-1.35v-25.19c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v25.19c0,.74-.6,1.35-1.35,1.35ZM537.65,498.83c-.74,0-1.35-.6-1.35-1.35v-31.49c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v31.49c0,.74-.6,1.35-1.35,1.35ZM537.65,461.04c-.74,0-1.35-.6-1.35-1.35v-18.89c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v18.89c0,.74-.6,1.35-1.35,1.35Z"
                          />
                          <path
                            className="st801"
                            d="M537.65,640.12c-.74,0-1.35-.6-1.35-1.35v-9.03c0-.74.6-1.35,1.35-1.35s1.35.6,1.35,1.35v9.03c0,.74-.6,1.35-1.35,1.35Z"
                          />
                        </motion.g>

                      </motion.svg>
                    </motion.g>

                    {/*  */}

                    {/* =======hat ==========*/}
                    <motion.g
                      animate={{
                        y:
                          hoveredLetter === "A1" ||
                            hoveredLetter === "N" ||
                            (hoveredLetter === "K" && isMobile)
                            ? contentHeight
                            : 0,
                      }}
                      transition={{ type: "spring", stiffness: 120 }}
                    >
                      <path d="M319.27,582.13l-53.06-22.43c-.83-.36-1.77-.37-2.6-.01l-11.35,4.75c-1.03.43-1.51,1.61-1.08,2.64.43,1.03,1.61,1.51,2.64,1.08l11.08-4.63,51.32,21.7-5.69,2.41-43.92-6.8c-1.1-.17-2.13.58-2.31,1.69-.17,1.1.58,2.13,1.69,2.31l37.45,5.8-5.92,2.5s-.09-.03-.14-.03c-.59,0-1.15.27-1.52.73l-30.96,13.09-51.59-21.77,32.43-13.59c1.03-.43,1.51-1.62,1.08-2.64s-1.62-1.51-2.64-1.08l-33.96,14.23c-1.24.54-2.03,1.77-2.02,3.12,0,1.34.81,2.54,2.04,3.06l20.16,8.51v24.07c.03,2.15,1.12,4.14,2.9,5.34,8.89,6.02,19.3,9.39,30.03,9.71.5.01,1,.02,1.5.02,6.46,0,12.87-1.11,18.95-3.29,1.05-.37,1.6-1.53,1.22-2.58-.37-1.05-1.53-1.6-2.58-1.22-15.66,5.62-33.07,3.4-46.82-5.95-.69-.44-1.13-1.2-1.16-2.02v-22.37l29.14,12.3c.42.18.87.28,1.33.28.44,0,.88-.09,1.28-.27l29.17-12.33v22.37c-.04.85-.49,1.63-1.22,2.09-1.24.84-2.56,1.65-3.94,2.41-.98.53-1.34,1.76-.81,2.74.53.98,1.76,1.34,2.74.81,0,0,.01,0,.02,0,1.49-.81,2.92-1.69,4.28-2.61,1.83-1.2,2.94-3.23,2.97-5.42v-24.08l9.35-3.95v26.67c-2.88,1.21-4.66,4.12-4.43,7.24-.01,1.49.34,2.96,1.03,4.27l-2.97,13.33c-.24,1.09.44,2.17,1.53,2.41.57.13,1.18,0,1.65-.35,3.02-2.28,7.19-2.28,10.22,0,.9.67,2.16.48,2.83-.41.37-.5.49-1.15.32-1.76l-3.77-13.28c.67-1.3,1.01-2.75.99-4.21.13-2.68-1.14-5.24-3.36-6.75v-28.85l6.47-2.74c1.71-.73,2.51-2.71,1.78-4.42-.34-.8-.97-1.43-1.77-1.77h0ZM310.23,623.21c.87,0,1.87,1.51,1.87,3.45s-1.01,3.45-1.87,3.45-1.87-1.51-1.87-3.45,1.01-3.45,1.87-3.45ZM313.82,640.99c-1.11-.29-2.26-.42-3.4-.41-1.08.02-2.15.18-3.19.48l1.59-7.14c.97.32,2.02.3,2.98-.06l2.02,7.12ZM248.99,621.04c1.12,0,2.02.9,2.02,2.02s-.9,2.02-2.02,2.02h-.4c-5.29.26-9.8-3.8-10.1-9.09,0-1.12.9-2.02,2.02-2.02s2.02.9,2.02,2.02c.31,3.05,3,5.3,6.06,5.05h.4Z" />
                    </motion.g>

                    {(hoveredLetter === "O2" || hoveredLetter === "O1") && isMobile && (<path
                      className="st8"
                      d="M754.12,870.14c-1.44-.19-2.88-.35-4.32-.43-5.61-.32-11.25-.59-16.86-.45-8.12.21-16.19,1.04-24.05,3.35-5.08,1.49-9.53,4.24-14.03,6.88-3,1.76-6.03,3.45-9.48,4.19-.84.18-1.71.33-2.57.33-1.88,0-3.75-.03-5.61.2l-.95-.75c-1.65-1.65-3.04-3.34-4.74-4.64-2.27-1.74-4.74-3.24-7.2-4.69-1.11-.65-2.39-1.06-3.65-1.38-1.05-.3-2.28-.07-2.28-.07.99-1.72,2.33-3.17,3.9-4.41,2.36-1.86,4.28-3.99,5.14-6.92.8-2.71,1.58-5.42,2.37-8.13l-.27-.13c-1.2.74-2.38,1.51-3.59,2.21-2.27,1.31-4.62,2.49-6.82,3.91-2.22,1.44-4.18,3.21-5.65,5.46-1.15,1.76-1.37,3.63-1.1,5.68.1,1.38-.67,1.4-.67,1.4-1.76.41-2.94,1.44-4.12,2.45-1.69,1.45-3.42,2.85-4.99,4.42-.64.64-1.22,1.64-1.26,2.51-.08,1.73-1.01,2.93-1.93,4.19-1.96,2.69-3.46,5.58-4.14,8.87-.23,1.12.27,1.56,1.49,1.35.52,1.14,2.23,1.79,3.77,1.43.18-.04.4-.17.52-.1,2.43,1.19,3.56.98,5.81-1.2.57-.55,1.13-1.14,1.57-1.79,1.13-1.67,2.97-1.84,4.67-2.29,2.02-.54,4.14-.9,5.75-2.31,0,0,1.29-1.08,1.87-.29.78,1,1.79,1.9,2.28,3.02.6,1.37.98,2.92,1.09,4.41.22,2.92.53,5.78,1.64,8.53,1.76,4.39,5.95,6.52,10.68,5.65,3.04-.56,6.18-.94,9.24.14.58.2,1.14.48,1.81.77-1.26-.11-2.36-.21-3.47-.31-.58-.05-.88.1-1.16.74-1.62,3.85-3.2,7.73-5.08,11.45-1.22,2.41-3,4.55-4.44,6.86-.88,1.41-2.12,3-1.09,4.66,1.46,2.35,3.36,4.38,6.45,4.57,1.59.09,3.18.21,4.77.22,1.91.02,4.94-2.27,5.5-4.06.31-.98,0-1.77-.7-2.62-.48,1.2-1.38,1.39-2.41,1.48-.52.05-1.02.43-1.54.67.05-1.03.99-1.01,1.86-1.3-.08-.61-.17-1.25-.28-2.03-.3.18-.46.23-.54.33-.99,1.35-1.54,1.54-3.12,1.04-.43-.13-.85-.26-1.28-.4-1.38-.43-1.63-.28-1.74,1.07-.02.29-.04.58-.08,1.04-.98-1.44-.51-2.67.29-3.68,1.73-2.18,3.5-4.33,5.43-6.33,4.28-4.43,7.94-9.3,10.98-14.63.47-.83.85-1.77,1.01-2.7.4-2.35-.61-4.23-2.52-5.51-2.14-1.44-4.32-2.88-6.65-3.96-2.47-1.14-3.22-2.89-2.83-5.47.2.64.39,1.21.57,1.77.53,1.66,2.08,2.16,3.41,2.87,2.12,1.13,4.33,2.09,6.41,3.28,4.52,2.58,4.71,6.32,2.07,10.34-1.17,1.78-2.25,3.61-3.35,5.43-.41.68-.42,1.09.6,1.28,3.75.68,7.45,1.74,11.22,2.15,3.03.33,6.14.02,9.21-.14,5.76-.3,11.17-2.3,16.74-3.53,3.23-.72,6.53-1.17,9.87-.58.2.04.43-.06.68-.1-.2-1.8-.39-3.53-.57-5.26-.15-1.46-.28-2.92-.43-4.37-.5-4.91-.95-9.84-3.45-14.26-.42-.74-.95-1.43-1.51-2.24,1.4.67,2.36,1.74,3.22,2.87,1.57,2.09,2.13,4.62,2.61,7.09.84,4.28,1.38,8.61,2.12,12.91.8,4.63,1.74,9.23,3.88,13.48,1.92,3.82,4.51,7.13,7.98,9.52,4.21-9.29,6.34-19.38,6.34-30.28,0-12.69-2.78-24.25-8.29-34.7Z"
                    />)}

                    <motion.g

                      animate={{
                        y:
                          hoveredLetter === "A1" ||
                            hoveredLetter === "A2" ||
                            hoveredLetter === "N" ||
                            hoveredLetter === "R" ||
                            hoveredLetter === "O1" && isMobile ||
                            hoveredLetter === "O2" && isMobile ||
                            (hoveredLetter === "K" && isMobile) ||
                            (hoveredLetter === "G" && isMobile)
                            ? ((hoveredLetter === "O1" && isMobile || hoveredLetter === "O2" && isMobile) ? contentHeight + 170 : contentHeight)
                            : 0,
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 120,
                        damping: 12,
                      }}
                    >
                      {hoveredLetter !== "O2" && (hoveredLetter !== "O1" || !isMobile) && (<path
                        className="st8"
                        d="M754.12,870.14c-1.44-.19-2.88-.35-4.32-.43-5.61-.32-11.25-.59-16.86-.45-8.12.21-16.19,1.04-24.05,3.35-5.08,1.49-9.53,4.24-14.03,6.88-3,1.76-6.03,3.45-9.48,4.19-.84.18-1.71.33-2.57.33-1.88,0-3.75-.03-5.61.2l-.95-.75c-1.65-1.65-3.04-3.34-4.74-4.64-2.27-1.74-4.74-3.24-7.2-4.69-1.11-.65-2.39-1.06-3.65-1.38-1.05-.3-2.28-.07-2.28-.07.99-1.72,2.33-3.17,3.9-4.41,2.36-1.86,4.28-3.99,5.14-6.92.8-2.71,1.58-5.42,2.37-8.13l-.27-.13c-1.2.74-2.38,1.51-3.59,2.21-2.27,1.31-4.62,2.49-6.82,3.91-2.22,1.44-4.18,3.21-5.65,5.46-1.15,1.76-1.37,3.63-1.1,5.68.1,1.38-.67,1.4-.67,1.4-1.76.41-2.94,1.44-4.12,2.45-1.69,1.45-3.42,2.85-4.99,4.42-.64.64-1.22,1.64-1.26,2.51-.08,1.73-1.01,2.93-1.93,4.19-1.96,2.69-3.46,5.58-4.14,8.87-.23,1.12.27,1.56,1.49,1.35.52,1.14,2.23,1.79,3.77,1.43.18-.04.4-.17.52-.1,2.43,1.19,3.56.98,5.81-1.2.57-.55,1.13-1.14,1.57-1.79,1.13-1.67,2.97-1.84,4.67-2.29,2.02-.54,4.14-.9,5.75-2.31,0,0,1.29-1.08,1.87-.29.78,1,1.79,1.9,2.28,3.02.6,1.37.98,2.92,1.09,4.41.22,2.92.53,5.78,1.64,8.53,1.76,4.39,5.95,6.52,10.68,5.65,3.04-.56,6.18-.94,9.24.14.58.2,1.14.48,1.81.77-1.26-.11-2.36-.21-3.47-.31-.58-.05-.88.1-1.16.74-1.62,3.85-3.2,7.73-5.08,11.45-1.22,2.41-3,4.55-4.44,6.86-.88,1.41-2.12,3-1.09,4.66,1.46,2.35,3.36,4.38,6.45,4.57,1.59.09,3.18.21,4.77.22,1.91.02,4.94-2.27,5.5-4.06.31-.98,0-1.77-.7-2.62-.48,1.2-1.38,1.39-2.41,1.48-.52.05-1.02.43-1.54.67.05-1.03.99-1.01,1.86-1.3-.08-.61-.17-1.25-.28-2.03-.3.18-.46.23-.54.33-.99,1.35-1.54,1.54-3.12,1.04-.43-.13-.85-.26-1.28-.4-1.38-.43-1.63-.28-1.74,1.07-.02.29-.04.58-.08,1.04-.98-1.44-.51-2.67.29-3.68,1.73-2.18,3.5-4.33,5.43-6.33,4.28-4.43,7.94-9.3,10.98-14.63.47-.83.85-1.77,1.01-2.7.4-2.35-.61-4.23-2.52-5.51-2.14-1.44-4.32-2.88-6.65-3.96-2.47-1.14-3.22-2.89-2.83-5.47.2.64.39,1.21.57,1.77.53,1.66,2.08,2.16,3.41,2.87,2.12,1.13,4.33,2.09,6.41,3.28,4.52,2.58,4.71,6.32,2.07,10.34-1.17,1.78-2.25,3.61-3.35,5.43-.41.68-.42,1.09.6,1.28,3.75.68,7.45,1.74,11.22,2.15,3.03.33,6.14.02,9.21-.14,5.76-.3,11.17-2.3,16.74-3.53,3.23-.72,6.53-1.17,9.87-.58.2.04.43-.06.68-.1-.2-1.8-.39-3.53-.57-5.26-.15-1.46-.28-2.92-.43-4.37-.5-4.91-.95-9.84-3.45-14.26-.42-.74-.95-1.43-1.51-2.24,1.4.67,2.36,1.74,3.22,2.87,1.57,2.09,2.13,4.62,2.61,7.09.84,4.28,1.38,8.61,2.12,12.91.8,4.63,1.74,9.23,3.88,13.48,1.92,3.82,4.51,7.13,7.98,9.52,4.21-9.29,6.34-19.38,6.34-30.28,0-12.69-2.78-24.25-8.29-34.7Z"
                      />)}
                      <path
                        className="st8"
                        d="M218.35,919.88c-14.88-.02-26.96,12.03-26.98,26.92v.03c.02,14.86,12.05,26.91,26.92,26.95,14.88.02,26.96-12.03,26.98-26.92.02-14.88-12.03-26.96-26.92-26.98ZM218.35,967.64c-11.48.02-20.8-9.28-20.82-20.76v-.06c-.03-11.46,9.23-20.78,20.69-20.82h.06v.06c11.48-.02,20.8,9.28,20.82,20.76.02,11.48-9.28,20.8-20.76,20.82Z"
                      />
                      <path
                        className="st8"
                        d="M226.45,952.37l-5.17-6.59v-11.92c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v12.96c0,.69.23,1.36.65,1.91l5.82,7.42c1.04,1.34,2.98,1.58,4.32.54,0,0,.01-.01.02-.02,1.33-1.05,1.56-2.97.52-4.31Z"
                      />
                      <path
                        className="st8"
                        d="M337.13,1164.55h-70.74v-170.02c0-.78-.3-1.53-.83-2.09l4.99-9.08.18-.59c.01-.2.01-.41,0-.62v-70.37c0-1.7-1.38-3.08-3.08-3.08h-11.55v-24.02c0-1.7-1.38-3.08-3.08-3.08h-1.54l-8.1-19.4-4.77-11.36-16.35-56.73c-.39-1.36-1.67-2.27-3.08-2.22-1.42-.05-2.7.88-3.08,2.25l-15.4,56.66-4.74,11.36-8.13,19.4h-4.77c-1.7,0-3.08,1.38-3.08,3.08v24.02h-11.24c-1.7,0-3.08,1.38-3.08,3.08v70.12c-.03.2-.03.41,0,.62-.01.19-.01.39,0,.59l5.2,9.42c-.38.51-.6,1.12-.62,1.76v170.3h-24.64c-1.7,0-3.08,1.38-3.08,3.08s1.38,3.08,3.08,3.08h191.52c1.7,0,3.08-1.38,3.08-3.08s-1.38-3.08-3.08-3.08ZM219.4,806.34l12.32,42.41h-23.93l11.61-42.41ZM205.82,854.9h27.72l2.25,5.42h-32.24l2.28-5.42ZM200.92,866.48h37.57l6.34,15.12h-50.2l6.28-15.12ZM186.11,887.76h63.84v20.94h-9.61v-10.41c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v10.47h-13.3v-10.47c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v10.47h-13.3v-10.47c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v10.47h-9.24l.09-21ZM260.23,1164.77h-19.89v-61.04c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v61.1h-13.3v-61.1c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v61.1h-13.3v-61.1c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v61.1h-18.48v-75.6h83.46v75.54ZM176.75,1079.31h83.46v3.76h-83.43l-.03-3.76ZM260.2,1073.15h-19.86v-63.13c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v63.13h-13.3v-63.13c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v63.13h-13.3v-63.13c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v63.13h-18.48v-75.54h83.46l-.03,75.54ZM259.06,991.45h-81.55l-3.57-6.5h88.69l-3.57,6.5ZM264.7,978.79h-92.88v-63.93h92.88v63.93Z"
                      />
                      <path
                        className="st8"
                        d="M119.96,1164.83h-38.99c-1.7,0-3.08,1.38-3.08,3.08s1.38,3.08,3.08,3.08h38.99c1.7,0,3.08-1.38,3.08-3.08s-1.38-3.08-3.08-3.08Z"
                      />
                      <path
                        className="st8"
                        d="M304.15,1147.89h-18.48c-1.7,0-3.08,1.38-3.08,3.08s1.38,3.08,3.08,3.08h18.48c1.7,0,3.08-1.38,3.08-3.08s-1.38-3.08-3.08-3.08Z"
                      />
                      <path
                        className="st8"
                        d="M140.56,1147.89h-29.44c-1.7,0-3.08,1.38-3.08,3.08s1.38,3.08,3.08,3.08h29.44c1.7,0,3.08-1.38,3.08-3.08s-1.38-3.08-3.08-3.08Z"
                      />
                      <path
                        className="st8"
                        d="M421.79,1109.74c-1.1,0-2.12-.59-2.66-1.55-.83-1.47-.31-3.33,1.16-4.16,1.01-.57,2.05-1.13,3.08-1.66.46-.23.92-.35,1.41-.35,1.16,0,2.2.64,2.73,1.67.76,1.5.16,3.34-1.34,4.11-.96.49-1.92,1.01-2.86,1.54-.46.26-.98.4-1.5.4h0Z"
                      />
                      <path
                        className="st8"
                        d="M389.98,1141.77c-.53,0-1.06-.14-1.52-.41-.71-.41-1.21-1.06-1.43-1.85-.21-.79-.11-1.61.3-2.32,6-10.7,14.01-19.85,23.82-27.2.53-.4,1.16-.61,1.83-.61.97,0,1.87.45,2.45,1.23.49.65.69,1.46.58,2.27-.12.81-.54,1.52-1.19,2.01-9.12,6.83-16.57,15.34-22.14,25.28-.58,1.02-1.6,1.6-2.69,1.6h0Z"
                      />
                      <path
                        className="st8"
                        d="M311.42,1240.35c-3.59,0-6.51-2.93-6.52-6.52v-16.42c0-3.59,2.92-6.52,6.52-6.52l13.26.03v-17.35c0-3.62,2.95-6.57,6.57-6.57h23.67v-15.93c0-3.6,2.92-6.52,6.52-6.52h1.8l.02-.39c1.52-37.45,26.78-69.44,62.86-79.61l.3-.08v-10.12l-.34-.06c-4.25-.69-7.33-4.32-7.33-8.63,0-4.81,3.92-8.72,8.73-8.72h.72l11.65-52.35-.25-.15c-2.51-1.51-4.07-4.27-4.07-7.2,0-4.62,3.77-8.38,8.39-8.38h2.29v-17.23c0-1.69,1.37-3.06,3.05-3.06s3.05,1.37,3.05,3.06v17.23h2.28c2.94,0,5.69,1.56,7.2,4.07,1.15,1.92,1.49,4.18.95,6.35-.54,2.17-1.9,4.01-3.82,5.16l-.25.15,11.65,52.35h.72c4.31,0,7.94,3.08,8.63,7.33.77,4.75-2.46,9.25-7.22,10.02l-.34.06v10.12l.3.08c36.08,10.17,61.35,42.16,62.88,79.62l.02.39h1.77c3.59,0,6.52,2.93,6.52,6.52v15.93h23.67c3.62,0,6.57,2.95,6.57,6.57v17.35l13.26-.03c3.59,0,6.52,2.92,6.52,6.52v16.42c0,3.59-2.93,6.51-6.52,6.52h0-275.68ZM506.34,1217.05v17.2h81.16v-17.23s-81.16.04-81.16.04ZM398.28,1234.24h101.96v-5.54h-101.96v5.54ZM311.01,1234.24h81.16v-17.19l-81.16-.04v17.23ZM398.28,1222.59h101.96v-5.54h-101.96v5.54ZM489.28,1210.94h78.45v-17.76l-.46-.05h-77.99v17.81ZM415.34,1210.94h67.83v-5.85h-67.83v5.85ZM330.78,1193.58v17.36s78.45,0,78.45,0v-17.81h-78.39l-.06.46ZM415.34,1198.98h67.83v-5.85h-67.83v5.85ZM361.03,1187.01h176.46v-16.34h-134.19c-1.68,0-3.05-1.37-3.05-3.05s1.37-3.05,3.05-3.05h125.89l-.02-.42c-1.84-42.98-36.95-76.64-79.91-76.64s-78.05,33.67-79.89,76.64l-.02.42h10.88c1.68,0,3.05,1.37,3.05,3.05s-1.37,3.05-3.05,3.05h-19.2v16.34ZM449.26,1081.39c5.44,0,10.91.52,16.26,1.55l.48.09v-8.61h-33.48v8.61l.48-.09c5.35-1.03,10.82-1.55,16.26-1.55ZM427.47,1063.06c-1.45,0-2.63,1.18-2.63,2.63,0,1.45,1.18,2.63,2.63,2.63h43.56c1.45,0,2.63-1.18,2.63-2.63s-1.18-2.63-2.63-2.63h-43.56ZM434.45,1056.95h29.61l-11.41-51.28h-6.79l-11.41,51.28ZM443.85,994.98c-1.26.02-2.27,1.07-2.25,2.33.02,1.24,1.05,2.25,2.29,2.25h10.7c1.33-.02,2.34-1.07,2.32-2.33-.02-1.24-1.05-2.25-2.29-2.25h-10.78Z"
                      />
                      <path
                        className="st8"
                        d="M750.68,1179.78l-45.13-20.38v-6.12l7.57-10.09h13.62c1.67,0,3.03-1.36,3.03-3.03v-9.08h.86c1.43,0,2.66-1,2.96-2.4.3-1.4-.43-2.81-1.73-3.39l-32.35-14.33v-10.34h6.94c1.67,0,3.03-1.36,3.03-3.03v-5.84h7.72c1.41,0,2.64-.98,2.95-2.36.31-1.38-.37-2.79-1.64-3.4l-37.62-18c-.41-.2-.85-.3-1.31-.3h-2.84v-7.72c0-1.67-1.36-3.03-3.03-3.03s-3.03,1.36-3.03,3.03v7.72h-1.86c-.45,0-.9.1-1.31.3l-37.62,18c-1.28.61-1.96,2.02-1.64,3.4.31,1.38,1.54,2.36,2.95,2.36h7.72v5.84c0,1.67,1.36,3.03,3.03,3.03h6.1v10.36l-31.54,14.32c-1.3.59-2.01,2-1.71,3.4.3,1.39,1.53,2.39,2.96,2.39h.03v9.08c0,1.67,1.36,3.03,3.03,3.03h14.18l7,10.03v6.15l-46.61,20.39c-1.31.57-2.04,1.99-1.75,3.39.29,1.4,1.53,2.41,2.96,2.41h6.05v9.08c0,1.67,1.36,3.03,3.03,3.03h15.13v12.11c0,1.67,1.36,3.03,3.03,3.03h9.08v9.08h-9.08c-1.67,0-3.03,1.36-3.03,3.03v9.39h-11.11c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03h123.61c1.67,0,3.03-1.36,3.03-3.03s-1.36-3.03-3.03-3.03h-12.63v-9.39c0-1.67-1.36-3.03-3.03-3.03h-6.05v-9.08h9.08c1.67,0,3.03-1.36,3.03-3.03v-12.11h18.16c1.67,0,3.03-1.36,3.03-3.03v-9.08h4.54c1.43,0,2.66-1,2.96-2.39.3-1.39-.41-2.81-1.71-3.39h0ZM669.51,1073.75h9.37l24.97,11.95h-59.32l24.97-11.95ZM644.98,1091.75h58.44v2.82h-58.44v-2.82ZM648.06,1155.3h51.45v3.03h-51.45v-3.03ZM657.14,1143.2h6.05v6.05h-6.05v-6.05ZM687.4,1149.25h-6.05v-6.05h6.05v6.05ZM675.29,1149.25h-6.05v-6.05h6.05v6.05ZM701.02,1149.25h-7.57v-6.05h12.11l-4.54,6.05ZM693.45,1109.91h-39.34v-9.08h39.34v9.08ZM651.74,1115.96h44.1l20.49,9.08h-84.58l19.99-9.08ZM623.85,1131.09h99.87v6.05h-99.87v-6.05ZM651.08,1143.2v6.05h-4.47l-4.23-6.05h8.7ZM645.66,1164.38h56.22l33.5,15.13h-124.31l34.59-15.13ZM626.87,1197.67h6.05v9.08h-6.05v-9.08ZM648.06,1197.67v9.08h-9.08v-9.08h9.08ZM663.19,1197.67v9.08h-9.08v-9.08h9.08ZM678.32,1197.67v9.08h-9.08v-9.08h9.08ZM693.45,1197.67v9.08h-9.08v-9.08h9.08ZM705.56,1197.67v9.08h-6.05v-9.08h6.05ZM684.37,1221.88v-9.08h9.08v9.08h-9.08ZM669.24,1221.88v-9.08h9.08v9.08h-9.08ZM654.11,1221.88v-9.08h9.08v9.08h-9.08ZM638.98,1212.8h9.08v9.08h-9.08v-9.08ZM714.64,1233.99h-87.76v-6.05h87.76v6.05ZM699.5,1221.88v-9.08h6.05v9.08h-6.05ZM717.66,1206.75h-6.05v-9.08h6.05v9.08ZM738.85,1191.62h-130.13v-6.05h130.13v6.05Z"
                      />
                      <path
                        className="st8"
                        d="M999.01,1240.35h-246.6c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h246.6c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M902.08,1240.35c-1.6,0-2.96-1.23-3.09-2.86l-11.62-149.59c-.13-1.71,1.14-3.2,2.85-3.33,1.71-.14,3.2,1.14,3.33,2.85l11.62,149.59c.13,1.71-1.14,3.2-2.85,3.33-.08,0-.16,0-.24,0Z"
                      />
                      <path
                        className="st8"
                        d="M868.6,1198.72c-.08,0-.16,0-.24,0-1.71-.13-2.98-1.62-2.85-3.33l8.35-107.97c.13-1.71,1.63-2.99,3.33-2.85,1.71.13,2.98,1.62,2.85,3.33l-8.35,107.97c-.13,1.62-1.48,2.86-3.09,2.86Z"
                      />
                      <path
                        className="st8"
                        d="M897.05,1090.23h-26.69c-6.12,0-11.09-4.98-11.09-11.09v-4.13c0-1.71,1.39-3.1,3.1-3.1h42.68c1.71,0,3.1,1.39,3.1,3.1v4.13c0,6.12-4.98,11.09-11.09,11.09ZM865.46,1078.1v1.04c0,2.7,2.2,4.9,4.9,4.9h26.69c2.7,0,4.9-2.2,4.9-4.9v-1.04h-36.49Z"
                      />
                      <path
                        className="st8"
                        d="M905.05,1053.54h-42.68c-1.71,0-3.1-1.39-3.1-3.1v-4.13c0-6.12,4.98-11.09,11.09-11.09h26.69c6.12,0,11.09,4.98,11.09,11.09v4.13c0,1.71-1.39,3.1-3.1,3.1ZM865.46,1047.35h36.49v-1.04c0-2.7-2.2-4.9-4.9-4.9h-26.69c-2.7,0-4.9,2.2-4.9,4.9v1.04Z"
                      />
                      <path
                        className="st8"
                        d="M906.92,1078.1h-46.43c-4.6,0-8.34-3.74-8.34-8.34v-14.09c0-4.6,3.74-8.34,8.34-8.34h46.43c4.6,0,8.34,3.74,8.34,8.34v14.09c0,4.6-3.74,8.34-8.34,8.34ZM860.49,1053.54c-1.18,0-2.14.96-2.14,2.14v14.09c0,1.18.96,2.14,2.14,2.14h46.43c1.18,0,2.14-.96,2.14-2.14v-14.09c0-1.18-.96-2.14-2.14-2.14h-46.43Z"
                      />
                      <path
                        className="st8"
                        d="M883.71,1041.41c-1.71,0-3.1-1.39-3.1-3.1v-47.66c0-1.71,1.39-3.1,3.1-3.1s3.1,1.39,3.1,3.1v47.66c0,1.71-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M875.5,1210.07c-1.18,0-2.31-.68-2.83-1.83-2.41-5.35-5.86-10.35-10.24-14.84-8.06-8.25-18.66-14.19-29.85-16.71-10.72-2.42-22.02-.95-32.68,4.25-1.54.75-3.39.11-4.14-1.43-.75-1.54-.11-3.39,1.43-4.14,11.95-5.82,24.66-7.46,36.76-4.72,12.34,2.79,24.03,9.33,32.92,18.43,4.89,5.01,8.75,10.6,11.46,16.62.7,1.56,0,3.39-1.55,4.1-.41.19-.84.27-1.27.27Z"
                      />
                      <path
                        className="st8"
                        d="M769.47,1210.18c-.47,0-.96-.11-1.41-.34-1.52-.78-2.13-2.64-1.35-4.17,3.1-6.07,7.04-11.65,11.7-16.57,1.18-1.24,3.14-1.29,4.38-.12,1.24,1.18,1.29,3.14.12,4.38-4.26,4.49-7.85,9.58-10.68,15.13-.55,1.07-1.63,1.69-2.76,1.69Z"
                      />
                      <path
                        className="st8"
                        d="M779.27,1217.26c-.42,0-.85-.09-1.26-.27-1.56-.7-2.27-2.53-1.57-4.09,7.92-17.8,27.58-31.21,45.74-31.21,16.73,0,38.42,11.59,45.75,30.98.6,1.6-.2,3.39-1.8,3.99-1.6.61-3.39-.2-3.99-1.8-6.29-16.66-25.64-26.97-39.95-26.97-15.86,0-33.09,11.84-40.08,27.54-.51,1.15-1.65,1.84-2.83,1.84Z"
                      />
                      <path
                        className="st8"
                        d="M865.21,1240.35h-86.05c-1.71,0-3.1-1.39-3.1-3.1v-22.03c0-1.71,1.39-3.1,3.1-3.1h86.05c1.71,0,3.1,1.39,3.1,3.1v22.03c0,1.71-1.39,3.1-3.1,3.1ZM782.26,1234.16h79.86v-15.83h-79.86v15.83Z"
                      />
                      <path
                        className="st8"
                        d="M779.15,1240.35h-17.71c-1.71,0-3.1-1.39-3.1-3.1v-29.91c0-1.71,1.39-3.1,3.1-3.1h17.71c1.71,0,3.1,1.39,3.1,3.1v29.91c0,1.71-1.39,3.1-3.1,3.1ZM764.54,1234.16h11.51v-23.72h-11.51v23.72Z"
                      />
                      <path
                        className="st8"
                        d="M882.91,1240.35h-17.71c-1.71,0-3.1-1.39-3.1-3.1v-29.91c0-1.71,1.39-3.1,3.1-3.1h17.71c1.71,0,3.1,1.39,3.1,3.1v29.91c0,1.71-1.39,3.1-3.1,3.1ZM868.3,1234.16h11.51v-23.72h-11.51v23.72Z"
                      />
                      <path
                        className="st8"
                        d="M847.9,1240.35h-17.15c-1.71,0-3.1-1.39-3.1-3.1v-22.03c0-1.71,1.39-3.1,3.1-3.1h17.15c1.71,0,3.1,1.39,3.1,3.1v22.03c0,1.71-1.39,3.1-3.1,3.1ZM833.85,1234.16h10.95v-15.83h-10.95v15.83Z"
                      />
                      <path
                        className="st8"
                        d="M813.6,1240.35h-17.15c-1.71,0-3.1-1.39-3.1-3.1v-22.03c0-1.71,1.39-3.1,3.1-3.1h17.15c1.71,0,3.1,1.39,3.1,3.1v22.03c0,1.71-1.39,3.1-3.1,3.1ZM799.55,1234.16h10.95v-15.83h-10.95v15.83Z"
                      />
                      <path
                        className="st8"
                        d="M949.34,1240.35h-35.76c-1.71,0-3.1-1.39-3.1-3.1v-122.8c0-1.71,1.39-3.1,3.1-3.1h35.76c1.71,0,3.1,1.39,3.1,3.1v122.8c0,1.71-1.39,3.1-3.1,3.1ZM916.68,1234.16h29.56v-116.61h-29.56v116.61Z"
                      />
                      <path
                        className="st8"
                        d="M924.25,1117.55c-1.71,0-3.1-1.39-3.1-3.1v-24.81c0-1.71,1.39-3.1,3.1-3.1s3.1,1.39,3.1,3.1v24.81c0,1.71-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M938.67,1117.55c-1.71,0-3.1-1.39-3.1-3.1v-14.89c0-1.71,1.39-3.1,3.1-3.1s3.1,1.39,3.1,3.1v14.89c0,1.71-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M936.65,1141.55h-10.38c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h10.38c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M936.65,1167.6h-10.38c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h10.38c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M936.65,1193.65h-10.38c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h10.38c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M936.65,1219.7h-10.38c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h10.38c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M989.98,1240.35h-27.62c-1.71,0-3.1-1.39-3.1-3.1v-117.34c0-1.71,1.39-3.1,3.1-3.1,16.94,0,30.72,13.78,30.72,30.72v6.3c0,1.71-1.39,3.1-3.1,3.1s-3.1-1.39-3.1-3.1v-6.3c0-12.47-9.36-22.8-21.43-24.33v110.95h21.43v-60.84c0-1.71,1.39-3.1,3.1-3.1s3.1,1.39,3.1,3.1v63.94c0,1.71-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M976.02,1154.58h-13.36c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h13.36c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M976.02,1180.63h-13.36c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h13.36c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M976.02,1206.67h-13.36c-1.71,0-3.1-1.39-3.1-3.1s1.39-3.1,3.1-3.1h13.36c1.71,0,3.1,1.39,3.1,3.1s-1.39,3.1-3.1,3.1Z"
                      />
                      <path
                        className="st8"
                        d="M796.72,1126.84c-13.2,0-23.94-10.74-23.94-23.94s10.74-23.94,23.94-23.94,23.94,10.74,23.94,23.94-10.74,23.94-23.94,23.94ZM796.72,1085.17c-9.78,0-17.74,7.96-17.74,17.74s7.96,17.74,17.74,17.74,17.74-7.96,17.74-17.74-7.96-17.74-17.74-17.74Z"
                      />
                    </motion.g>

                    <g>


                      {hoveredLetter === "A1" && (
                        <rect
                          key="hover-A1"
                          x="390"
                          y="190"
                          width="295"
                          height="560"
                          fill="transparent"
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => setHoveredLetter("A1")}
                          onMouseLeave={() => {
                            if (!isMobile) {
                              setHoveredLetter(null);
                            }
                          }}

                        />
                      )}

                      {hoveredLetter === "N" && (
                        <rect
                          key="hover-N"
                          x="425"
                          y="475"
                          width="145"
                          height="280"
                          fill="transparent"
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => setHoveredLetter("N")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        />
                      )}
                      {hoveredLetter === "A1" && isMobile === true && (
                        <motion.foreignObject
                          key="A1-mobile-2"
                          x="700"
                          y="410"
                          width="100%"
                          height="100%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("A1")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <img src={imageBaseApi + filterA1?.[0]?.media?.url} style={{ width: "25%" }} alt="" />
                        </motion.foreignObject>
                      )}


                      {hoveredLetter === "A1" && isMobile === true && (
                        <motion.foreignObject
                          key="A1-mobile-1"
                          x="-45"
                          y="480"
                          width="100%"
                          height="22%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible", }}
                          onMouseEnter={() => setHoveredLetter("A1")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <div xmlns="http://www.w3.org/1999/xhtml">
                            <AustralianSVG
                              style={{
                                width: "100%",
                                height: "100%",

                              }}
                              data={filterA1}
                              isMobile={isMobile}
                              setHoveredLetter={setHoveredLetter}
                            />
                          </div>
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "N" && isMobile === true && (
                        <motion.foreignObject
                          key="N-mobile-2"
                          x="-150"
                          y="480"
                          width="100%"
                          height="22%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("N")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <img src={imageBaseApi + filterN?.[0]?.media?.url} style={{ width: "30%" }} alt="" />
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "N" && isMobile === true && (
                        <motion.foreignObject
                          key="N-mobile-1"
                          x="215"
                          y="480"
                          width="100%"
                          height="22%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible", }}
                          onMouseEnter={() => setHoveredLetter("N")}
                        >
                          <div xmlns="http://www.w3.org/1999/xhtml">
                            <Ncomponent setHoveredLetter={setHoveredLetter} isMobile={isMobile}
                              data={filterN}
                              style={{ width: "100%", height: "100%" }}
                            />
                          </div>
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "G" && isMobile === true && (
                        <motion.foreignObject
                          key="G-mobile-2"
                          x="-30"
                          y="680"
                          width="100%"
                          height="32%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("G")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <img src={imageBaseApi + filterG?.[0]?.media?.url} style={{ width: "25%" }} alt="" />
                        </motion.foreignObject>
                      )}


                      {hoveredLetter === "G" && isMobile === true && (
                        <motion.foreignObject
                          key="G-mobile"
                          x="-10"
                          y="800"
                          width="100%"
                          height="22%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("G")}

                        >
                          <div xmlns="http://www.w3.org/1999/xhtml">
                            <Gcomponent
                              style={{ width: "100%", height: "100%" }}
                              isMobile={isMobile}
                              data={filterG}
                            />
                          </div>

                        </motion.foreignObject>
                      )}



                      {hoveredLetter === "A2" && isMobile === true && (
                        <motion.foreignObject
                          key="A2-mobile"
                          x="-10"
                          y="800"
                          width="100%"
                          height="22%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("A2")}

                        >
                          <div xmlns="http://www.w3.org/1999/xhtml">
                            <A2component
                              style={{ width: "100%", height: "100%" }}
                              isMobile={isMobile}
                              data={filterA2}
                            />
                          </div>
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "A2" && isMobile === true && (
                        <motion.foreignObject
                          key="A2-mobile-2"
                          x="840"
                          y="600"
                          width="100%"
                          height="28%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("A2")}

                        >
                          <img src={imageBaseApi + filterA2?.[0]?.media?.url} style={{ width: "35%" }} alt="" />
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "R" && isMobile === true && (
                        <motion.foreignObject
                          key="R-mobile-2"
                          x="-45"
                          y="680"
                          width="100%"
                          height="32%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("R")}

                        >
                          <img src={imageBaseApi + filterR?.[0]?.media?.url} style={{ width: "21%" }} alt="" />
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "R" && isMobile === true && (
                        <motion.foreignObject
                          key="R"
                          x="-40"
                          y="790"
                          width="100%"
                          height="22%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("R")}

                        >
                          <div xmlns="http://www.w3.org/1999/xhtml">
                            <Rcomponent isMobile={isMobile}
                              data={filterR}
                              style={{ width: "100%", height: "100%" }}
                            />
                          </div>
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "O1" && isMobile === true && (
                        <motion.foreignObject
                          key="O1-mobile-2"
                          x="-0"
                          y="935"
                          width="100%"
                          height="32%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("O1")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <img src={imageBaseApi + filterO1?.[0]?.media?.url} style={{ width: "23%" }} alt="" />
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "O1" && isMobile === true && (
                        <motion.foreignObject
                          key="O1-mobile"
                          x="350"
                          y="900"
                          width="40%"
                          height="100%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{
                            overflow: "visible",
                            transformOrigin: "top left",
                          }}
                          onMouseEnter={() => setHoveredLetter("O1")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <div
                            style={{
                              width: "105%",
                              height: "20%",
                              transform: "scale(2.5) translateX(-145px)",
                              transformOrigin: "top left",
                            }}
                          >
                            <O1component isMobile={isMobile} data={filterO1} />
                          </div>
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "O2" && isMobile === true && (
                        <motion.foreignObject
                          key="O2-mobile-2"
                          x="5"
                          y="780"
                          width="100%"
                          height="32%"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          style={{ overflow: "visible" }}
                          onMouseEnter={() => setHoveredLetter("O2")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        >
                          <img src={imageBaseApi + filterO2?.[0]?.media?.url} style={{ width: "30%" }} alt="" />
                        </motion.foreignObject>
                      )}

                      {hoveredLetter === "O2" && isMobile === true && (
                        <motion.foreignObject
                          key="O2"
                          x="10"
                          y="1060"
                          width="100%"
                          height="100%"
                          variants={o2Variants}
                          initial="hidden"
                          animate="visible"
                          exit="exit"
                          style={{ overflow: "visible" }}
                          onClick={() => router(filterO2?.[0]?.buttonUrl)}
                        >
                          <div xmlns="http://www.w3.org/1999/xhtml">
                            <O2component setHoveredLetter={setHoveredLetter} isMobile={isMobile} data={filterO2}
                              style={{ width: "100%", height: "100%" }}
                            />
                          </div>
                        </motion.foreignObject>
                      )}
















                      <AnimatePresence>





                        {hoveredLetter !== "R" && hoveredLetter !== "A2" && hoveredLetter !== "A1" && (<rect
                          x="290"
                          y="775"
                          width="275"
                          height="280"
                          fill="transparent"
                          style={{ cursor: "pointer" }}
                          onMouseEnter={() => setHoveredLetter("O1")}
                          onMouseLeave={() => setHoveredLetter(null)}
                        />)}
                        <AnimatePresence mode="wait">

                          {hoveredLetter !== "A2" && hoveredLetter !== "R" && hoveredLetter !== "N" && (
                            <rect
                              x="535"
                              y="735"
                              width="275"
                              height="310"
                              fill="transparent"
                              style={{ cursor: "pointer" }}
                              onMouseEnter={() => setHoveredLetter("O2")}
                              onMouseLeave={() => setHoveredLetter(null)}
                            />
                          )}


                          {hoveredLetter === "O2" && isMobile === false && (
                            <motion.foreignObject
                              key="O2"
                              x="-810"
                              y="560"
                              width="100%"
                              height="100%"
                              variants={o2Variants}
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              style={{ overflow: "visible", pointerEvents: "none" }}
                            >
                              <div xmlns="http://www.w3.org/1999/xhtml">
                                <O2component setHoveredLetter={setHoveredLetter} isMobile={isMobile} data={filterO2}
                                  style={{ width: "100%", height: "100%" }}
                                />
                              </div>
                            </motion.foreignObject>
                          )}
                          {hoveredLetter === "O2" && isMobile === false && (
                            <motion.foreignObject
                              key="A2-image"
                              x={-800}
                              y={40}
                              width="60%"
                              height="50%"
                              variants={o2Variants}
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              style={{ overflow: "visible", pointerEvents: "none" }}
                            >
                              <div
                                xmlns="http://www.w3.org/1999/xhtml"
                                style={{ width: "100%", height: "100%" }}
                              >
                                <img
                                  src={imageBaseApi + filterO2?.[0]?.media?.url}
                                  style={{ width: "90%", }}
                                  alt="hello"
                                />
                              </div>
                            </motion.foreignObject>
                          )}

                        </AnimatePresence>

                        {hoveredLetter === "A2" && (
                          <g>

                            <rect
                              x="390"
                              y="475"
                              width="295"
                              height="330"
                              fill="transparent"
                              style={{ cursor: "pointer" }}
                              onMouseEnter={() => setHoveredLetter("A2")}
                              onMouseLeave={() => setHoveredLetter(null)}
                            />

                          </g>


                        )}


                      </AnimatePresence>
                    </g>
                  </g>

                </svg>    
              </Col>
            </Row>
          </div>
        </div>
      </SectionContainer>
      <Container fluid className=" position-relative" style={{ background: "linear-gradient(to left, #e3e2e8, #f9f9fb)", marginBottom: "8rem" }}>
        <div
          style={{
            width: 'clamp(4rem, 12vw, 8rem)',
            height: 'clamp(4.4rem, 13.2vw, 10rem)',
            background: 'linear-gradient(to right, #7e1790, #d70a84)',
            clipPath: 'polygon(0 0, 100% 50%, 0 100%)',
            filter: 'drop-shadow(0 0 clamp(10px, 2vw, 20px) rgba(137, 2, 149, 0.3))',
            position: 'absolute',
            left: -6,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1
          }}
        ></div>
        <Container className="h-100" fluid style={{ width: "1509px" }}>
          <JoinSuccess data={filterDiscover} />
        </Container>
      </Container>
      <SectionContainer mainId="Page6">
        <Explore />
      </SectionContainer>
      <SectionContainer mainId="Page3">
        <LearnMore data={filterEmpower} />
        <hr className="line" style={{ marginTop: "0rem" }} />
      </SectionContainer>
      <SectionContainer mainId="Professional">
        <Professional />
        <hr className="line" />
      </SectionContainer>
      <SectionContainer mainId="Page4">
        <DestinationSelect data={filterTest} />
      </SectionContainer>
      <SectionContainer mainId="SmallPage">
        <SmallPage />
      </SectionContainer>
      <SectionContainer mainId="Page7">
        <Review />
        <hr className="line" />
      </SectionContainer>
      <SectionContainer mainId="Page8">
        <Map />
        <hr className="line" />
      </SectionContainer>
      <SectionContainer>
        <Professional2 />

      </SectionContainer>
      {/* <SectionContainer mainId="Page5">
        <SmartPreparation />
        <hr className="line" />
      </SectionContainer> */}





      {/* <SectionContainer mainId="Page11">
        <Page11 />
        </SectionContainer> */}

    </div>
  );
};

export default Homepage;
